/* eslint-disable no-unused-vars */
import store from '@/store'
import { ForgeMessage } from './../../utils/forgeMessageUtils'
import HttpService from '../../utils/httpService'
import { getViewPage360, launchViewer } from './forgeviewer'
import { getURLParameterVal } from './../../store/helpers'
import { toPoint2D, isPointInsidePolygon, drawLine } from '../../utils/threejsUtils'
import { editType, saveLevels, saveScaffolds, postData, postDataAsync, getAttachments, getJSON } from '../../utils/mongoUtils'
import { getAMISTagById } from '../../utils/amisAPIs'
import { axisAngleToEuler } from '../../utils/geometryUtils'
import { getMiddleBBoxForGroup, checkIsModelTrasnlated, addViewable, setPermeativeElementsTheme, createGrayMaterial, getNodeChildDbidsForNode, createMaterial, isolateForge, getBBBox, getAllLeafComponents } from '../../utils/forgeUtils'
import { ForgeInspection, ForgeObject, ForgeAnnotation, ForgeEquipment, ForgeScaffold, ForgeAttachment, Image360, ForgeInspectionSubTag, ShareFileItem, ForgePipeline, ForgeStructural } from './forgeModels'
import config from '../../../appConfig'
import $ from 'jquery'
import { BlobServiceClient, StorageSharedKeyCredential, ContainerClient, BlockBlobClient } from '@azure/storage-blob';
import { AnonymousCredential } from '@azure/identity';
import { jsPDF } from 'jspdf';
import 'pannellum'
import 'pannellum/src/css/pannellum.css'

const Proj4js = window.Proj4js;
const pannellum = window.pannellum;
const THREE = window.THREE;
const Autodesk = window.Autodesk;
const pdfjsLib = window.pdfjsLib;

export class ForgeViewerService {

    constructor() {
        this.allForgeElements = [];
        this.dbIdPerObj = [];
        this.smallModelsUrnsPerElements = new Map();

        // 0 => Gray
        // 1 => Wireframe
        // 2 => Shaded 
        this.ThemingStack = [];

        // ghosting
        this.fragIdPerMaterial = null;
        this.ghostingMaterial = null;
        this.dbIdPerThemingColor = {};

        this.pointCloudsToShowIn3D = [];
        this.scaffoldStates = [
            { state: 'USE WITHOUT HARNESS', color: '#92D050' },
            { state: 'USE ONLY WITH HARNESS', color: '#ffa500' },
            { state: 'DO NOT USE', color: '#ff0000' },
        ];
        this.permitsStates = [
            { state: 'Permit Preparation', color: '#00000' },
            { state: 'Issuing Authority Review', color: '#00000' },
            { state: 'Permit Coordinator Review', color: '#00000' },
            { state: 'Concurrence signature Authority Review', color: '#00000' },
            { state: 'Affected Area Review', color: '#00000' },
            { state: 'Validation', color: '#00000' },
            { state: 'Site Issuing Authority Review', color: '#00000' },
            { state: 'Pending Live', color: '#00000' },
            { state: 'Live PTW', color: '#00000' },
            { state: 'To be Closed', color: '#00000' },
        ];
        this.permitStatuses = ["Permit Raised", "Permit Live", "Permit Closed"]
        this.gpsSystems = ["Default", "Indian 1975/UTM 47N"];
        this.unitsList = ['decimal-ft', 'ft-and-fractional-in', 'ft-and-decimal-in', 'decimal-in', 'm', 'cm', 'mm'];

        this.panoViewerId = 'panorama';

        this.startedPanoChange;
        this.panoramaViewer;

        this.lockedFOV_360;

        this.image360ToNavigateToIn3D = null;
        this.tagToZoomToIn3D = null;
        this.pointToZoomToIn2d = null;

        this.isCroppingForPointCloudDownload = false;
        this.amisTagToPickObjectTo = null;

        //mapping point
        this.isPickingMappingPoint1;
        this.isPickingMappingPoint2;
        this.mappedPoint1 = { generalViewPoint: null, planViewPoint: null }
        this.mappedPoint2 = { generalViewPoint: null, planViewPoint: null }

        var _this = this;

        this.panoCustomSceneId = 'customScene';
        this.clusterIds = [];

        let moveHandler = () => {
            if (!_this.panoramaViewer || !store.state.selectedImage || !store.state.selectedImage.isLocked || !_this.startedPanoChange || !_this.getMainExtension() || !store.state.areViewsLocked)
                return;
            _this.updateforgeViewerFromPano(store.state.selectedImage);
            _this.panoramaViewer.stopMovement()
        };

        window.ontouchmove = moveHandler;
        window.onmousemove = moveHandler;
    }

    initializeMappingPointsEvents(viewer, isGeneralViewer) {
        if (!viewer)
            return;
        //https://stackoverflow.com/questions/53511258/forge-viewer-how-to-convert-arbitrary-client-point-to-world-point
        let canvas = viewer.canvas;
        let drag = false;
        canvas.addEventListener('mousedown', () => drag = false);
        canvas.addEventListener('mousemove', () => drag = true);
        canvas.addEventListener('mouseup', (evt) => {
            if (drag || !store.state.selectedLevel)
                return;
            var hitTest = viewer.clientToWorld(evt.offsetX, evt.offsetY, false);
            if (!hitTest)
                return;
            let modelScale = viewer.model.getUnitScale()
            if (this.isPickingMappingPoint1) {
                if (isGeneralViewer)
                    this.mappedPoint1.generalViewPoint = hitTest.point.clone().add(viewer.model.getGlobalOffset()).multiplyScalar(modelScale);
                else
                    this.mappedPoint1.planViewPoint = hitTest.point;
                if (this.mappedPoint1.generalViewPoint && this.mappedPoint1.planViewPoint)
                    this.isPickingMappingPoint1 = false;
                store.state.adminAppContainer.isPoint1Valid = this.mappedPoint1.generalViewPoint && this.mappedPoint1.planViewPoint;

            } else if (this.isPickingMappingPoint2) {
                if (isGeneralViewer)
                    this.mappedPoint2.generalViewPoint = hitTest.point.clone().add(viewer.model.getGlobalOffset()).multiplyScalar(modelScale);
                else
                    this.mappedPoint2.planViewPoint = hitTest.point;
                if (this.mappedPoint2.generalViewPoint && this.mappedPoint2.planViewPoint)
                    this.isPickingMappingPoint2 = false;
                store.state.adminAppContainer.isPoint2Valid = this.mappedPoint2.generalViewPoint && this.mappedPoint2.planViewPoint;
            }
            let point1OnLevel = this.mappedPoint1.planViewPoint;
            let point1OnModel = this.mappedPoint1.generalViewPoint;
            let point2OnLevel = this.mappedPoint2.planViewPoint;
            let point2OnModel = this.mappedPoint2.generalViewPoint;
            if (point1OnLevel && point1OnModel && point2OnLevel && point2OnModel) {

                store.state.selectedLevel.fillAlignment(point1OnLevel, point1OnModel, point2OnLevel, point2OnModel)
                saveLevels(store.state.selectedLevel, editType.EDIT_LEVEL);
                this.getMappingExtension3D().updateShownLevels();
            }

        });
    }
    launchPanoViewer(image) {
        if (this.panoramaViewer)
            this.panoramaViewer.destroy();
        if (getViewPage360())
            getViewPage360().clearPanoDimension();


        //TODO: remove later
        if (!image.rotationAngle)
            image.rotationAngle = Math.abs(image.lockedYaw);
        //get Horizon Pitch & Roll
        let horizonRoll, horizonPitch = 0;
        if (image.rotationAngle && image.rotationX && image.rotationY && image.rotationZ) {
            var rotation = axisAngleToEuler(image.rotationX, image.rotationY, image.rotationZ, image.rotationAngle)
            horizonPitch = rotation.y;
            horizonRoll = -rotation.x;
        }
        else if (image.scanType == 'geoslam') {
            horizonRoll = image.rotationX
            horizonPitch = image.rotationY
        }

        this.panoramaViewer = pannellum.viewer('panoramaContainer', {
            "type": "equirectangular",
            "panorama": image.imageUrl,
            "autoLoad": true,
            "yaw": image.lockedYaw,
            "pitch": image.lockedPitch,
            "horizonPitch": horizonPitch,
            "horizonRoll": horizonRoll,
            // "hotSpotDebug": true,
            "compass": true,
            "northOffset": -image.lockedYaw + 90,
            "scenes": {
                'customScene': {
                    type: "equirectangular",
                    panorama: image.imageUrl,
                    autoLoad: true
                }
            }
        });

        this.panoramaViewer.loadScene(this.panoCustomSceneId, image.lockedPitch, image.lockedYaw, this.panoramaViewer.getHfov());

        let viewer = store.state.viewer;
        if (viewer)
            this.panoramaViewer.setHfovBounds([viewer.navigation.getFovMin(), viewer.navigation.getFovMax()])

        this.panoramaViewer.forgeImage = image;
        //update shown
        this.getAllPanoramaImages().forEach(o => o.isShown = false);
        image.isShown = true;
        if (store.state.selectedTab == 3)
            this.scrollToImage360(image);

        store.state.selectedImage = image;
        store.commit('hideThumbnailPopup', '360');

        let onPointerDown = () => {
            store.commit('hideThumbnailPopup', '360');
            if (!store.state.selectedImage || !store.state.selectedImage.isLocked) return;
            //to stop updating Pano viewer from forge
            _this.startedPanoChange = true;
        }

        let onPointerUp = (event) => {
            if (event.button != 0) {
                return
            }
            if (!store.state.selectedImage || !store.state.selectedImage.isLocked)
                return;
            if (!store.state.isPickingTag && !store.state.isPickingPin)
                return;
            if (!store.state.pointClouds.some(o => o.isShown)) {
                store.dispatch({ type: "alert_Forge", message: 'Please turn on a PointCloud first' })
                return;
            }
            let intersection = _this.img360MouseTo3DPoint(event);
            if (!intersection) {
                store.dispatch({ type: "alert_Forge", message: 'Please turn on a PointCloud that intersects with your tag point.' })
                return;
            }
            intersection = _this.view3dToWorld(intersection)

            if (store.state.isPickingTag) {
                //clear selection first not to include any 3d elements in the tag
                viewer?.impl?.selector?.clearSelection();
                _this.addNewTag("360", intersection, false, true);
            } else if (store.state.isPickingPin) {
                let coordinates = _this.panoramaViewer.mouseEventToCoords(event);
                store.state.pinnedPoint360 = { point: intersection, imgName: image.name, yaw: coordinates[1], pitch: coordinates[0] }
                _this.updatePinnedPointIn360()
                $('#panorama').css('cursor', 'hand')
            }
        }

        var _this = this;
        this.panoramaViewer.on('touchstart', onPointerDown);
        this.panoramaViewer.on('touchend', onPointerUp)
        this.panoramaViewer.on('mousedown', onPointerDown);
        this.panoramaViewer.on('mouseup', onPointerUp);
        this.panoramaViewer.on('load', (e) => {
            let callback = store.getters['getLoad360ViewerCallback'];
            if (callback) callback();
            store.commit('setLoad360ViewerCallback', null);
        });

        var mousewheelevt = (/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel";
        this.panoramaViewer.getContainer().addEventListener(mousewheelevt, (evt) => {
            store.commit('hideThumbnailPopup', '360');
            // if(mainApp.showComparasionTool && _this.lockedFOV_360){
            //     store.state.forgeService.panoramaViewer.setHfov(_this.lockedFOV_360,false)
            //     _this.panoramaViewer.stopMovement()
            //     return;
            // }

            if (!viewer || !store.state.areViewsLocked || !store.state.selectedImage || !_this.panoramaViewer)
                return;
            _this.panoramaViewer.stopMovement()

            ///===== Old ways to map the HFOV with 3d FOV =====///
            // var fov = _this.panoramaViewer.getHfov();

            // 1- oldest way and not used from  4-2022
            // var ratio = (fov - 50.0) / 70.0;
            // var newFocalLength = 25 - 15 * ratio;
            // viewer.navigation.setFocalLength(newFocalLength);

            // 2- Not used from 10-2022
            // if(mainApp.localShowComparasionTool)
            //     fov = store.state.forgeService.getComparasionModeFOV(fov);
            // viewer.navigation.setFocalLength(viewer.navigation.fov2fl(fov));
            ///===============================================///

            // The newest way.
            this.mapPanoramaHFovTo3dVHov();
        });

        let handleMouseUp = () => {
            _this.startedPanoChange = false;
            if (store.state.viewer) {
                let walkEx = store.state.viewer.getExtension('Autodesk.BimWalk');
                if (walkEx)
                    walkEx.deactivate();
            }
        };

        window.onmouseup = handleMouseUp;
        window.ontouchend = handleMouseUp;

        this.panoramaViewer.lookAt(image.lockedPitch, image.lockedYaw, this.panoramaViewer.getHfov(), 0);

        this.updatePinnedPointIn360()
        this.updateTagsAnnotationsInPanoViewer();
        this.update360ImagesHotspots();
    }
    getFittestHFov() {
        // This function is used to get fittest HFOV for 3d viewer.
        // IMPORTANT: Not implemented yet.
        let newHFov = this.panoramaViewer.getHfov();
        let notFit = true;
        while (notFit) {
            let vFov = this.get3dVFovFormPanoramaHFov(newHFov);

            let min = store.state.viewer.navigation.getFovMin()
            let max = store.state.viewer.navigation.getFovMax()

            if (vFov > max) {
                newHFov -= 1
            } else if (vFov < min) {
                newHFov += 1
            } else {
                notFit = false;
            }
        }
        return newHFov;
    }
    img360MouseTo3DPoint(event) {
        let coordinates = this.panoramaViewer.mouseEventToCoords(event);
        const ray = new THREE.Raycaster();
        let imagePt = this.panoramaViewer.forgeImage.getCameraPositionInViewer();
        let newTarget = this.imageYawPitchToPoint3D(this.panoramaViewer.forgeImage, coordinates[1], coordinates[0]);
        let direction = newTarget.clone().sub(imagePt.clone()).normalize();
        ray.set(imagePt, direction);

        //test ray
        // drawLine(imagePt,imagePt.clone().add(direction.multiplyScalar(10)),0x0000ff, store.state.viewer, 'test-overlay')

        let clientPoint = store.state.viewer.worldToClient(newTarget)

        let modelIntersection = store.state.viewer?.impl?.castRay(clientPoint.x, clientPoint.y, false)?.point;

        let pointCloudIntersection = this.getMainExtension().getPointCloudIntersectionWithRaycaster(ray)

        return pointCloudIntersection || modelIntersection;
    }
    getClosestImageToPoint(point) {
        var images = store.state.projects.flatMap(o => o.images);
        if (images.length == 0)
            return null;
        images.sort((a, b) => {
            if (a.getCameraPositionInViewer().distanceTo(point) < b.getCameraPositionInViewer().distanceTo(point))
                return -1;
            return 1;
        });

        return images[0];
    }
    updatePinnedPointIn360() {
        $('.pnlm-ui').css('cursor', '')
        if (!store.state.pinnedPoint360 || store.state.pinnedPoint360.imgName != store.state.selectedImage.name)
            return
        function hotspot(hotSpotDiv, args) {
            hotSpotDiv.classList.add('custom-tooltip');
            var personIcon = document.createElement('div');
            personIcon.className = `person-icon pinned-point-360`;
            hotSpotDiv.appendChild(personIcon);
        }
        let pinnedId = 'pinnedPoint'
        let hotspotImg = {
            id: pinnedId,
            "pitch": store.state.pinnedPoint360.pitch,
            "yaw": store.state.pinnedPoint360.yaw,
            "cssClass": "custom-hotspot-pinned",
            "createTooltipFunc": hotspot,
            "createTooltipArgs": '',
            "clickHandlerFunc": function (event) {
            },
            "clickHandlerArgs": 'test',
        };
        this.panoramaViewer.removeHotSpot(pinnedId, this.panoCustomSceneId);
        this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
        store.commit('setIsPickingPin', false);
    }
    removePinnedPointIn360() {
        store.state.pinnedPoint360 = null
        store.commit('setIsPickingPin', false);
    }
    update360ImagesHotspots() {
        if (!this.panoramaViewer)
            return;

        let image = this.panoramaViewer.forgeImage;
        //remove existing images
        let allImages = store.state.projects.flatMap(o => o.images);
        allImages.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.name, this.panoCustomSceneId);
        });

        let visibilityRange = store.state.userSettings.displaySettings.getVisibilityRange();
        var nearImages = [];
        if (store.state.userSettings.displaySettings.show360)
            nearImages = store.state.forgeService.getAllShownPanoramaImagesIn3D();

        nearImages = nearImages.filter(o => o != image && o.name != image.name && o.forgeCameraPosition.distanceTo(image.forgeCameraPosition) < visibilityRange);

        let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == 0;

        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'])
            nearImages = nearImages.filter(o => store.state.filtered360Imgs.includes(o));
        if (nearImages.length == 0)
            return;

        var _this = this;

        function hotspot(hotSpotDiv, args) {
            var imagePath = require(`@/images/${args.scanType.charAt(0).toUpperCase() + args.scanType.slice(1)}.png`);

            hotSpotDiv.classList.add('custom-tooltip');
            var personIcon = document.createElement('img');
            personIcon.className = `person-icon ${args.scanType}-icon`;
            personIcon.src = imagePath;
            hotSpotDiv.appendChild(personIcon);
            //All calculated in meters
            var devicePixelRatio = window.devicePixelRatio;

            let unitScale = store.state.viewer?.model?.getUnitScale() ?? 1.0

            var scaleFactor = 1 / unitScale;

            var distanceFromCamera = args.forgeCameraPosition.distanceTo(image.forgeCameraPosition) * scaleFactor;

            let newWidth = 30.0 * (30.0 / (distanceFromCamera + 1.0)) * scaleFactor;

            if (newWidth < 30) newWidth = 30;

            // Max gl_PointSize value
            if (newWidth > 1024.0) newWidth = 1024.0;

            newWidth /= devicePixelRatio;

            personIcon.style.width = newWidth + 'px';
            personIcon.style.height = newWidth + 'px';

            personIcon.addEventListener("mouseover", function (e) {
                let personIconBoundry = personIcon.getBoundingClientRect();

                let width = personIconBoundry.width ? personIconBoundry.width : 20 // personIcon css class default width
                var hotSpotDivStyle = window.getComputedStyle(hotSpotDiv);
                var matrix = new window.WebKitCSSMatrix(hotSpotDivStyle.transform);

                const text = args.name;
                const font = "16px ArtifaktElement"
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                context.font = font;
                const offset = context.measureText(text);

                let textWidth = offset.width > 200 ? offset.width : 200;

                store.commit("setTooltipObject", {
                    title: args.name,
                    position: {
                        left: matrix.m41,
                        top: matrix.m42 - 40
                    },
                    margin: (width / 2) - ((textWidth + 20) / 2) // tooltip width + 20 padding
                });
            })

            personIcon.addEventListener("mouseout", function (e) {
                store.commit("setTooltipObject", null);
            })
        }
        nearImages.forEach(o => {
            var direction = new THREE.Vector3();
            direction.subVectors(o.forgeCameraPosition, image.forgeCameraPosition).normalize();
            var info = _this.getNewYawAndPitch(image, direction);
            let hotspotImg = {
                id: o.name,
                "pitch": info['pitch'],
                "yaw": info['yaw'],
                "cssClass": "custom-hotspot",
                "createTooltipFunc": hotspot,
                "createTooltipArgs": o,
                "clickHandlerFunc": function (event) {
                    _this.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                },
                "clickHandlerArgs": 'test',
            };
            this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
        });
    }
    updateTagsAnnotationsInPanoViewer() {
        if (!this.panoramaViewer) return;

        let tags = store.state.tags.filter(o => !o.level2D);
        let autoTags = store.getters['GET_ALL_EXISTING_AUTOMATIC_TAGS'];
        let manualPipelines = store.getters.GET_MANUAL_PIPELINES_TAGS.filter(o => !o.level2D);
        let manualStructural = store.getters.GET_MANUAL_STRUCTURAL_TAGS.filter(o => !o.level2D);
        let annotations = store.state.annotations.filter(o => !o.level2D);
        let scaffolds = store.state.scaffolds;
        //remove old tags/annotations
        tags.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });
        manualPipelines.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });
        manualStructural.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });
        annotations.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });
        scaffolds.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });

        let image = this.panoramaViewer.forgeImage;

        function hotspot(hotSpotDiv, args) {
            var imagePath = require(`@/images/${args.imageName}`);

            var label = document.createElement('div');
            label.className = args.className;

            var icon = document.createElement('img');
            icon.className = 'tag-360 ' + args.imgClass;
            icon.src = imagePath;
            label.appendChild(icon);

            var textDiv = document.createElement('div');
            textDiv.innerText = args.title;
            textDiv.className = 'tag-title';
            label.appendChild(textDiv);

            if (args.category)
                store.state.forgeService.addCategoryColorToLabel(args.category, label);
            hotSpotDiv.appendChild(label);
        }
        //add new tags
        let _this = this;
        let visRange = store.state.userSettings.displaySettings.getVisibilityRange();

        let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == 0;

        let filteredTags = [];
        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
            for (let i = 0; i < tags.length; i++) {
                if (!store.state.filteredTags.includes(tags[i]))
                    continue;
                filteredTags.push(tags[i]);
            }
        } else {
            filteredTags = tags;
        }

        filteredTags = filteredTags.filter(o => o.point && o.point.distanceTo(image.forgeCameraPosition) < visRange);
        filteredTags.forEach(o => {
            if (store.state.userSettings.displaySettings.showTags) {
                var direction = new THREE.Vector3();
                direction.subVectors(o.point, image.forgeCameraPosition).normalize();
                var info = this.getNewYawAndPitch(image, direction);
                let hotspotIcon = {
                    id: o.id,
                    "pitch": info['pitch'],
                    "yaw": info['yaw'],
                    "cssClass": "custom-hotspot",
                    "createTooltipFunc": hotspot,
                    "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
                    "clickHandlerFunc": function (event) {
                        _this.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                    },
                    "clickHandlerArgs": 'test',
                };
                this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
            }
        });

        let autoEquipments = [];


        autoEquipments.forEach(o => {
            if (store.state.userSettings.displaySettings.showAutoEquipment) {
                var direction = new THREE.Vector3();
                direction.subVectors(o.point, image.forgeCameraPosition).normalize();
                var info = this.getNewYawAndPitch(image, direction);
                let hotspotIcon = {
                    id: o.id,
                    "pitch": info['pitch'],
                    "yaw": info['yaw'],
                    "cssClass": "custom-hotspot",
                    "createTooltipFunc": hotspot,
                    "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
                    "clickHandlerFunc": function (event) {
                        store.dispatch('getAutomaticTagTagById', o.id).then(tag => {
                            store.state.forgeService.onClickOn3dIcon(tag, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                        })
                    },
                    "clickHandlerArgs": 'test',
                };
                this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
            }
        });

        //add new annotations
        let filteredAnnotations = [];
        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
            for (let i = 0; i < annotations.length; i++) {
                if (!store.state.filteredAnnotations.includes(annotations[i]))
                    continue;
                filteredAnnotations.push(annotations[i]);
            }
        } else
            filteredAnnotations = annotations;
        filteredAnnotations = filteredAnnotations.filter(o => o.point && o.point.distanceTo(image.forgeCameraPosition) < visRange);
        filteredAnnotations.forEach(o => {
            if (store.state.userSettings.displaySettings.showAnnotations) {
                var direction = new THREE.Vector3();
                direction.subVectors(o.point, image.forgeCameraPosition).normalize();
                var info = this.getNewYawAndPitch(image, direction);

                let hotspotIcon = {
                    id: o.id,
                    "pitch": info['pitch'],
                    "yaw": info['yaw'],
                    "cssClass": "custom-hotspot",
                    "createTooltipFunc": hotspot,
                    "createTooltipArgs": { title: o.name, category: o.category, className: 'annotation-3d-pano', imgClass: 'annotation-360-hotspot', imageName: 'Annotation.png' },
                    "clickHandlerFunc": function (event) {
                        _this.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                    },
                    "clickHandlerArgs": 'test',
                };
                this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
            }
        });

        this.updateAutoEquipmentHotSpots(visRange, hotspot);

        // this.updatePipelinesHotSpots(visRange, hotspot);

        // this.updateStructuralHotSpots(visRange, hotspot);

        this.updateInspectionsHotSpots(visRange, hotspot);

        this.updateFetchedInspectionsHotSpots(visRange, hotspot);

        // add pipelines
        let filteredPipelines = [];
        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
            for (let i = 0; i < manualPipelines.length; i++) {
                if (!store.state.filteredManualPipelines.includes(manualPipelines[i]))
                    continue;
                filteredPipelines.push(manualPipelines[i]);
            }
        } else {
            filteredPipelines = manualPipelines;
        }

        filteredPipelines = filteredPipelines.filter(o => o.point && o.point.distanceTo(image.forgeCameraPosition) < visRange);
        filteredPipelines.forEach(o => {
            if (store.state.userSettings.displaySettings.showManualPipelines) {
                var direction = new THREE.Vector3();
                direction.subVectors(o.point, image.forgeCameraPosition).normalize();
                var info = this.getNewYawAndPitch(image, direction);

                let hotspotIcon = {
                    id: o.id,
                    "pitch": info['pitch'],
                    "yaw": info['yaw'],
                    "cssClass": "custom-hotspot",
                    "createTooltipFunc": hotspot,
                    "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
                    "clickHandlerFunc": function (event) {
                        _this.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                    },
                };
                this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
            }
        });

        // add structural
        let filteredStructural = [];
        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
            for (let i = 0; i < manualStructural.length; i++) {
                if (!store.state.filteredManualStructural.includes(manualStructural[i]))
                    continue;
                filteredStructural.push(manualStructural[i]);
            }
        } else {
            filteredStructural = manualStructural;
        }

        filteredStructural = filteredStructural.filter(o => o.point && o.point.distanceTo(image.forgeCameraPosition) < visRange);
        filteredStructural.forEach(o => {
            if (store.state.userSettings.displaySettings.showManualStructural) {

                var direction = new THREE.Vector3();

                direction.subVectors(o.point, image.forgeCameraPosition).normalize();

                var info = this.getNewYawAndPitch(image, direction);

                let hotspotIcon = {
                    id: o.id,
                    "pitch": info['pitch'],
                    "yaw": info['yaw'],
                    "cssClass": "custom-hotspot",
                    "createTooltipFunc": hotspot,
                    "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
                    "clickHandlerFunc": function (event) {
                        _this.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                    },
                };

                this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
            }
        });

        //add scaffolds
        let filteredScaffolds = [];
        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
            for (let i = 0; i < scaffolds.length; i++) {
                if (scaffolds[i].isScaffold() && !store.state.filteredScaffolds.includes(scaffolds[i]))
                    continue;
                else if (scaffolds[i].isPermit() && !store.state.filteredPermits.includes(scaffolds[i]))
                    continue;
                else if (scaffolds[i].isContainer() && !store.state.filteredContainers.includes(scaffolds[i]))
                    continue;

                filteredScaffolds.push(scaffolds[i]);
            }
        }
        else {
            for (let i = 0; i < scaffolds.length; i++) {
                if ((scaffolds[i].isScaffold() && store.state.userSettings.displaySettings.showScaffolds) ||
                    (scaffolds[i].isPermit() && store.state.userSettings.displaySettings.showPermits) ||
                    (scaffolds[i].isContainer() && store.state.userSettings.displaySettings.showDeckManagment))
                    filteredScaffolds.push(scaffolds[i]);
            }
        }

        filteredScaffolds = filteredScaffolds.filter(o => o.position && o.position.distanceTo(image.forgeCameraPosition) < visRange);
        filteredScaffolds.forEach(o => {
            var direction = new THREE.Vector3();
            direction.subVectors(o.position, image.forgeCameraPosition).normalize();
            var info = this.getNewYawAndPitch(image, direction);

            let imgClass = 'scaffold-360-hotspot';
            let imageName = "Scaffold.png";

            if (o.isPermit()) {
                imgClass = 'permit-360-hotspot';
                imageName = "Permit.png";
            }
            else if (o.isContainer()) {
                imgClass = 'container-360-hotspot';
                imageName = "Container.png";
            }

            let hotspotIcon = {
                id: o.id,
                "pitch": info['pitch'],
                "yaw": info['yaw'],
                "cssClass": "custom-hotspot",
                "createTooltipFunc": hotspot,
                "createTooltipArgs": { title: o.name, className: 'scaffold-3d-pano', imgClass: imgClass, imageName: imageName },
                "clickHandlerFunc": function (event) {
                    _this.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                },
                "clickHandlerArgs": 'test',
            };
            this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
        });
    }
    updateAutoEquipmentHotSpots(visRange, hotspot) {
        let autoTags = store.getters['GET_ALL_EXISTING_AUTOMATIC_TAGS'];

        autoTags.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });

        this.clusterIds.forEach(o => {
            this.panoramaViewer.removeHotSpot(o, this.panoCustomSceneId);
        })

        this.clusterIds = [];

        if (!store.state.userSettings.displaySettings.showAutoEquipment) return;

        let image = this.panoramaViewer?.forgeImage;

        let position = image?.forgeCameraPosition;

        if (!image || !position) return;

        let useGlobalSearch = store.state.isTabShown && store.state.selectedTab == 0 && store.getters['GET_GLOBAL_SEARCH_TEXT'];

        autoTags.forEach(o => {
            o.point = Object.assign(new THREE.Vector3(), o.point)
        });

        let autoEquipments = useGlobalSearch ? store.getters['GET_AUTOMATIC_TAGS'] : autoTags;

        autoEquipments = autoEquipments.filter(o => o.point && o.point.distanceTo(position) < visRange);

        let { items, clusters } = store.state.forgeService.getTagsClustersAndItems(autoEquipments, position, visRange);

        clusters.forEach((o, index) => {
            var box = new THREE.Box3().setFromPoints(o.map(o => o.point));
            var center = box.getCenter();
            var direction = new THREE.Vector3();
            direction.subVectors(center, position).normalize();
            var info = this.getNewYawAndPitch(image, direction);
            var id = `auto-tag-cluster-${index}`;
            let hotspotImg = {
                id: id,
                "pitch": info['pitch'],
                "yaw": info['yaw'],
                "cssClass": "custom-hotspot",
                "createTooltipFunc": this.clusterHotSpot,
                "createTooltipArgs": { items: o, position: center, image: image },
                "clickHandlerFunc": (event, args) => {
                    console.log(event, args);
                    store.commit("setTooltipObject", null);
                    this.clusterIds = this.clusterIds.filter(i => i !== args.id);
                    this.panoramaViewer.removeHotSpot(args.id, this.panoCustomSceneId);
                    args.items.forEach(o => {
                        this.addTagHotSpot(o, position, image, hotspot);
                    })
                },
                "clickHandlerArgs": { id: id, items: o, index },
            };
            this.clusterIds.push(id);
            this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
        });

        items.forEach(o => {
            this.addTagHotSpot(o, position, image, hotspot);
        });

    }
    addTagHotSpot(o, position, image, hotspot) {
        var direction = new THREE.Vector3();
        direction.subVectors(o.point, position).normalize();
        var info = this.getNewYawAndPitch(image, direction);
        let hotspotIcon = {
            id: o.id,
            "pitch": info['pitch'],
            "yaw": info['yaw'],
            "cssClass": "custom-hotspot",
            "createTooltipFunc": hotspot,
            "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
            "clickHandlerFunc": function (event) {
                store.dispatch('getAutomaticTagTagById', o.id).then(tag => {
                    store.state.forgeService.onClickOn3dIcon(tag, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                });
            },
            "clickHandlerArgs": 'test',
        };
        this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
    }
    updateStructuralHotSpots(visRange, hotspot) {
        let tags = store.getters.GET_ALL_EXISTING_STRUCTURAL_TAGS;

        tags.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });

        this.clusterIds.forEach(o => {
            this.panoramaViewer.removeHotSpot(o, this.panoCustomSceneId);
        })

        this.clusterIds = [];

        if (!store.state.userSettings.displaySettings.showStructural) return;

        let image = this.panoramaViewer?.forgeImage;

        let position = image?.forgeCameraPosition;

        if (!image || !position) return;

        let useGlobalSearch = store.state.isTabShown && store.state.selectedTab == 0 && store.getters['GET_GLOBAL_SEARCH_TEXT'];

        tags.forEach(o => {
            o.point = Object.assign(new THREE.Vector3(), o.point)
        });

        let structuralTags = useGlobalSearch ? store.getters['GET_STRUCTURAL_TAGS'] : tags;

        structuralTags = structuralTags.filter(o => o.point && o.point.distanceTo(position) < visRange);

        let { items, clusters } = store.state.forgeService.getTagsClustersAndItems(structuralTags, position, visRange);

        clusters.forEach((o, index) => {
            var box = new THREE.Box3().setFromPoints(o.map(o => o.point));
            var center = box.getCenter();
            var direction = new THREE.Vector3();
            direction.subVectors(center, position).normalize();
            var info = this.getNewYawAndPitch(image, direction);
            var id = `auto-tag-cluster-${index}`;
            let hotspotImg = {
                id: id,
                "pitch": info['pitch'],
                "yaw": info['yaw'],
                "cssClass": "custom-hotspot",
                "createTooltipFunc": this.clusterHotSpot,
                "createTooltipArgs": { items: o, position: center, image: image },
                "clickHandlerFunc": (event, args) => {
                    console.log(event, args);
                    store.commit("setTooltipObject", null);
                    this.clusterIds = this.clusterIds.filter(i => i !== args.id);
                    this.panoramaViewer.removeHotSpot(args.id, this.panoCustomSceneId);
                    args.items.forEach(o => {
                        this.addStructuralHotSpot(o, position, image, hotspot);
                    })
                },
                "clickHandlerArgs": { id: id, items: o, index },
            };
            this.clusterIds.push(id);
            this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
        });

        items.forEach(o => {
            this.addStructuralHotSpot(o, position, image, hotspot);
        });
    }
    addStructuralHotSpot(o, position, image, hotspot) {
        var direction = new THREE.Vector3();
        direction.subVectors(o.point, position).normalize();
        var info = this.getNewYawAndPitch(image, direction);
        let hotspotIcon = {
            id: o.id,
            "pitch": info['pitch'],
            "yaw": info['yaw'],
            "cssClass": "custom-hotspot",
            "createTooltipFunc": hotspot,
            "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
            "clickHandlerFunc": function (event) {
                store.dispatch('FETCH_STRUCTURAL_TAG_BY_ID', o.id).then(tag => {
                    store.state.forgeService.onClickOn3dIcon(tag, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                });
            },
            "clickHandlerArgs": 'test',
        };
        this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
    }
    updatePipelinesHotSpots(visRange, hotspot) {
        let tags = store.getters.GET_ALL_EXISTING_PIPELINES_TAGS;

        tags.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });

        this.clusterIds.forEach(o => {
            this.panoramaViewer.removeHotSpot(o, this.panoCustomSceneId);
        })

        this.clusterIds = [];

        if (!store.state.userSettings.displaySettings.showStructural) return;

        let image = this.panoramaViewer?.forgeImage;

        let position = image?.forgeCameraPosition;

        if (!image || !position) return;

        let useGlobalSearch = store.state.isTabShown && store.state.selectedTab == 0 && store.getters['GET_GLOBAL_SEARCH_TEXT'];

        tags.forEach(o => {
            o.point = Object.assign(new THREE.Vector3(), o.point)
        });

        let pipelineTags = useGlobalSearch ? store.getters['GET_PIPELINES_TAGS'] : tags;

        pipelineTags = pipelineTags.filter(o => o.point && o.point.distanceTo(position) < visRange);

        let { items, clusters } = store.state.forgeService.getTagsClustersAndItems(pipelineTags, position, visRange);

        clusters.forEach((o, index) => {
            var box = new THREE.Box3().setFromPoints(o.map(o => o.point));
            var center = box.getCenter();
            var direction = new THREE.Vector3();
            direction.subVectors(center, position).normalize();
            var info = this.getNewYawAndPitch(image, direction);
            var id = `auto-tag-cluster-${index}`;
            let hotspotImg = {
                id: id,
                "pitch": info['pitch'],
                "yaw": info['yaw'],
                "cssClass": "custom-hotspot",
                "createTooltipFunc": this.clusterHotSpot,
                "createTooltipArgs": { items: o, position: center, image: image },
                "clickHandlerFunc": (event, args) => {
                    console.log(event, args);
                    store.commit("setTooltipObject", null);
                    this.clusterIds = this.clusterIds.filter(i => i !== args.id);
                    this.panoramaViewer.removeHotSpot(args.id, this.panoCustomSceneId);
                    args.items.forEach(o => {
                        this.addPipelineHotSpot(o, position, image, hotspot);
                    })
                },
                "clickHandlerArgs": { id: id, items: o, index },
            };
            this.clusterIds.push(id);
            this.panoramaViewer.addHotSpot(hotspotImg, this.panoCustomSceneId);
        });

        items.forEach(o => {
            this.addPipelineHotSpot(o, position, image, hotspot);
        });
    }
    addPipelineHotSpot(o, position, image, hotspot) {
        var direction = new THREE.Vector3();
        direction.subVectors(o.point, position).normalize();
        var info = this.getNewYawAndPitch(image, direction);
        let hotspotIcon = {
            id: o.id,
            "pitch": info['pitch'],
            "yaw": info['yaw'],
            "cssClass": "custom-hotspot",
            "createTooltipFunc": hotspot,
            "createTooltipArgs": { title: o.name, category: o.category, className: 'tag-3d-pano', imgClass: 'tag-360-hotspot', imageName: 'Equipment.png' },
            "clickHandlerFunc": function (event) {
                store.dispatch('FETCH_PIPELINE_TAG_BY_ID', o.id).then(tag => {
                    store.state.forgeService.onClickOn3dIcon(tag, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                });
            },
            "clickHandlerArgs": 'test',
        };
        this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
    }
    updateInspectionsHotSpots(visRange, hotspot) {
        let inspections = store.state.inspections.filter(o => !o.level2D);

        inspections.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });

        if (!store.state.userSettings.displaySettings.showInspections && !store.state.forgeSettings.isAMIS) return;

        let image = this.panoramaViewer?.forgeImage;

        let position = image?.forgeCameraPosition;

        if (!image || !position) return;

        let useGlobalSearch = store.state.isTabShown && store.state.selectedTab == 0 && store.getters['GET_GLOBAL_SEARCH_TEXT'];

        let filteredInspections = [];

        if (useGlobalSearch) {
            filteredInspections = store.state.filteredInspections.filter(t => t.point);
        } else if (store.state.TAGS.InspectionSelectedFilter && store.state.TAGS.selectedColorOptions.length) {
            filteredInspections = store.getters['GET_FILTERED_INSPECTIONS'].filter(t => t.point);
        }

        filteredInspections = filteredInspections.filter(o => o.point && o.point.distanceTo(position) < visRange);

        filteredInspections.forEach(o => {
            this.addInspectionHotSpot(o, position, image, hotspot);
        });
    }
    updateFetchedInspectionsHotSpots(visRange, hotspot) {
        let inspections = store.getters['GET_ALL_AMIS_TAGS_IDS'];

        inspections.forEach(o => {
            this.panoramaViewer.removeHotSpot(o.id, this.panoCustomSceneId);
        });

        if (!store.state.userSettings.displaySettings.showInspections && store.state.forgeSettings.isAMIS) return;

        let image = this.panoramaViewer?.forgeImage;

        let position = image?.forgeCameraPosition;

        if (!image || !position) return;

        let useGlobalSearch = store.state.isTabShown && store.state.selectedTab == 0 && store.getters['GET_GLOBAL_SEARCH_TEXT'];

        let filteredInspections = [];

        if (useGlobalSearch) {
            filteredInspections = store.state.filteredInspections.filter(t => t.point);
        } else if (store.state.TAGS.InspectionSelectedFilter && store.state.TAGS.selectedColorOptions.length) {
            filteredInspections = store.getters['GET_ALL_AMIS_FILTERED_INSPECTIONS'].filter(t => t.point);
        }

        filteredInspections = filteredInspections.filter(o => o.point && o.point.distanceTo(position) < visRange);

        filteredInspections.forEach(o => {
            this.addInspectionHotSpot(o, position, image, hotspot);
        });
    }
    addInspectionHotSpot(o, position, image, hotspot) {
        var direction = new THREE.Vector3();
        direction.subVectors(o.point, position).normalize();
        var info = this.getNewYawAndPitch(image, direction);

        let hotspotIcon = {
            id: o.id,
            "pitch": info['pitch'],
            "yaw": info['yaw'],
            "cssClass": "custom-hotspot",
            "createTooltipFunc": hotspot,
            "createTooltipArgs": { title: o.name, category: o.category, className: 'annotation-3d-pano', imgClass: 'inspection-360-hotspot', imageName: "Inspection.png" },
            "clickHandlerFunc": function (event) {
                if (o instanceof ForgeInspection) {
                    store.state.forgeService.onClickOn3dIcon(o, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                } else {
                    getAMISTagById(o.id).then(tag => {
                        store.state.forgeService.onClickOn3dIcon(tag, { offsetX: event.layerX, offsetY: event.layerY }, '360');
                    });
                }
            },
            "clickHandlerArgs": 'test',
        };
        this.panoramaViewer.addHotSpot(hotspotIcon, this.panoCustomSceneId);
    }
    clusterHotSpot(hotSpotDiv, args) {
        let image = args.image;

        var imagePath = require(`@/images/Equipment.png`);

        hotSpotDiv.classList.add('custom-tooltip');
        var personIcon = document.createElement('img');
        personIcon.className = `person-icon cluster-icon`;
        personIcon.src = imagePath;
        hotSpotDiv.appendChild(personIcon);
        //All calculated in meters
        var devicePixelRatio = window.devicePixelRatio;
        let unitScale = store.state.viewer?.model?.getUnitScale() ?? 1.0
        var scaleFactor = 1 / unitScale;
        var distanceFromCamera = args.position.distanceTo(image.forgeCameraPosition) * scaleFactor * 2;
        let newWidth = 30.0 * (30.0 / (distanceFromCamera + 1.0)) * scaleFactor;
        if (newWidth < 40) newWidth = 40;

        // Max gl_PointSize value
        if (newWidth > 1024.0) newWidth = 1024.0;
        newWidth /= devicePixelRatio;

        personIcon.style.width = newWidth + 'px';
        personIcon.style.height = newWidth + 'px';

        personIcon.addEventListener("mouseover", function (e) {
            let personIconBoundry = personIcon.getBoundingClientRect();

            let width = personIconBoundry.width ? personIconBoundry.width : 20 // personIcon css class default width
            var hotSpotDivStyle = window.getComputedStyle(hotSpotDiv);
            var matrix = new window.WebKitCSSMatrix(hotSpotDivStyle.transform);

            const text = `Count: ${args.items.length ?? 0}`;
            const font = "16px ArtifaktElement"
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = font;
            const offset = context.measureText(text);

            let textWidth = offset.width > 200 ? offset.width : 200;

            store.commit("setTooltipObject", {
                title: `Count: ${args.items.length ?? 0}`,
                position: {
                    left: matrix.m41,
                    top: matrix.m42 - 40
                },
                margin: (width / 2) - ((textWidth + 20) / 2) // tooltip width + 20 padding
            });
        })

        personIcon.addEventListener("mouseout", function (e) {
            store.commit("setTooltipObject", null);
        })
    }
    showImageInViews(image) {
        if (!getViewPage360()) {
            store.state.mainApp.openViewPageWithType('360');
        } else {
            store.state.mainApp.showViewPageWithType('360');
        }

        setTimeout(() => {
            if (store.state.viewer) {
                this.getAllPanoramaImages().forEach(o => o.isShown = false);
                image.isShown = true;
                //pano viewer
                this.launchPanoViewer(image);

                //forge viewer
                this.navigateIn3D(image);
                getViewPage360().is360Locked = true;
            }
            else
                this.launchPanoViewer(image);
        }, 100);
    }
    navigateIn3D(image) {
        if (!store.state.viewer?.model)
            return;

        if (this.panoramaViewer) {
            ///===== Old way to map the 3d viewer with panorama viewer =====///
            // var fov = this.panoramaViewer.getHfov();
            // if (mainApp.localShowComparasionTool) {
            //     fov = store.state.forgeService.getComparasionModeFOV(fov);
            // }                
            // viewer.navigation.setFocalLength(viewer.navigation.fov2fl(fov));
            ///=============================================================///
            this.mapPanoramaHFovTo3dVHov();
        }

        store.commit('hideThumbnailPopup', '3d');

        store.state.viewer.navigation.setPosition(image.getCameraPositionInViewer());
        var newTarget = store.state.viewer.navigation.getPosition().add(image.lockedForgeDirection);
        store.state.viewer.navigation.setTarget(newTarget);
        store.state.viewer.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));
        setTimeout(() => {
            image.viewerLockedState = store.state.viewer.getState();
        }, 100);
        store.state.viewer.navigation.setLockSettings({ "walk": true, "fov": true });
        //viewer.navigation.setIsLocked(true);
        let walkExt = store.state.viewer.getExtension('Autodesk.BimWalk');
        if (walkExt) {
            walkExt.activate();
            setTimeout(() => {
                $('.c-bimwalk-tooltip__actions #dontRemind').click()
            }, 50)
            walkExt.deactivate();
            walkExt.tool.navigator.enableGravity(false);
        }
        if (this.panoramaViewer)
            store.state.areViewsLocked = true;
    }
    dbidToForgeObject(dbid, model) {
        var instanceTree = model.getData().instanceTree;

        if (!instanceTree) return null;

        var elem = new ForgeObject();
        elem.dbId = dbid;
        elem.center = getMiddleBBoxForGroup([dbid], model).getCenter().clone().add(model.getGlobalOffset());
        elem.name = model.getInstanceTree().getNodeName(dbid);

        return elem;
    }

    updatePanoViewerFromForge(image) {
        var newDirection = store.state.viewer.navigation.getCamera().getWorldDirection();
        var info = this.getNewYawAndPitch(image, newDirection);

        this.panoramaViewer.lookAt(info['pitch'], info['yaw'], this.panoramaViewer.getHfov(), 0)
        getViewPage360()?.updatePanoDimensionLineInformation();
    }
    scrollToImage360(image) {
        //expand and scroll to element
        let level = store.state.projects.find(o => o.images.includes(image));
        level.isExpanded = true;
        setTimeout(() => {
            let elem = document.getElementById('image360_' + image.id);
            if (elem)
                elem.scrollIntoView();
        }, 500);
    }
    getNewYawAndPitch(image, newDirection) {

        //set yaw
        var startVec2D = toPoint2D(image.lockedForgeDirection);
        var newVec2D = toPoint2D(newDirection);
        var angle = THREE.Math.radToDeg(startVec2D.angleTo(newVec2D));
        if (startVec2D.cross(newVec2D).z > 0)
            angle = -angle;
        angle += image.lockedYaw;
        if (angle > 180)
            angle -= 360;
        else if (angle < -180)
            angle += 360;

        //set pitch
        var verticalAngle = THREE.Math.radToDeg(newDirection.angleTo(newVec2D));
        if (newDirection.z < 0)
            verticalAngle = -verticalAngle;
        verticalAngle += image.lockedPitch;
        if (verticalAngle > 180)
            verticalAngle -= 360;
        else if (verticalAngle < -180)
            verticalAngle += 360;
        return { 'yaw': angle, 'pitch': verticalAngle };
    }
    linkViewers(forceLock) {
        if (!store.state.selectedImage || !store.state.viewer?.model || (store.state.areViewsLocked && !forceLock)) return;

        // Camera Position
        store.state.viewer.navigation.setPosition(store.state.selectedImage.getCameraPositionInViewer());

        // Camera Target
        let yaw = store.state.forgeService.panoramaViewer.getYaw();
        let pitch = store.state.forgeService.panoramaViewer.getPitch();
        let newTarget = store.state.forgeService.imageYawPitchToPoint3D(store.state.selectedImage, yaw, pitch);
        store.state.viewer.navigation.setTarget(newTarget);
        store.state.viewer.navigation.setCameraUpVector(new THREE.Vector3(0, 0, 1));

        // FOV
        ///===== Old way to link 3d with panorama and map FOV between them =====///
        // var fov = store.state.forgeService.panoramaViewer.getHfov();
        // if (mainApp.localShowComparasionTool) fov = store.state.forgeService.getComparasionModeFOV(fov);
        // viewer.navigation.setFocalLength(viewer.navigation.fov2fl(fov));
        ///=====================================================================///
        this.mapPanoramaHFovTo3dVHov();

        setTimeout(() => {
            store.state.selectedImage.viewerLockedState = store.state.viewer.getState();
        }, 100);

        // BimWalk
        store.state.viewer.navigation.setLockSettings({ "walk": false, "fov": true });
        let walkExt = store.state.viewer.getExtension('Autodesk.BimWalk');
        if (walkExt) {
            walkExt.activate();
            setTimeout(() => {
                $('.c-bimwalk-tooltip__actions #dontRemind').click()
            }, 50)
            walkExt.deactivate();
            walkExt.tool.navigator.enableGravity(false);
        }

        // Lock viewers
        store.state.areViewsLocked = true;
    }
    updateforgeViewerFromPano(image) {
        let newTarget = this.imageYawPitchToPoint3D(image, this.panoramaViewer.getYaw(), this.panoramaViewer.getPitch());
        store.state.viewer.navigation.setTarget(newTarget);
        getViewPage360()?.updatePanoDimensionLineInformation();

        //update up direction
        let camera = store.state.viewer.getCamera();
        camera.up = new THREE.Vector3(0, 0, 1);
        store.state.viewer.applyCamera(camera)
    }
    imageYawPitchToPoint3D(image, yaw, pitch) {
        //get right 2D direction
        var deltaYaw = yaw - image.lockedYaw;
        //set the direction of the axis to make right rotation
        var axis = new THREE.Vector3(0, 0, deltaYaw > 0 ? -1 : 1);
        //remove the negative sign as the rotation direction is handled by the axis
        deltaYaw = Math.abs(deltaYaw);
        var vec2D = toPoint2D(image.lockedForgeDirection);
        vec2D.applyAxisAngle(axis, THREE.Math.degToRad(deltaYaw));
        let cameraPosition = image.getCameraPositionInViewer();
        var newTarget = cameraPosition.clone().add(vec2D);

        //get z
        var deltaPitch = pitch - image.lockedPitch;
        var dist = toPoint2D(cameraPosition).distanceTo(toPoint2D(newTarget));
        var z = dist * Math.tan(THREE.Math.degToRad(deltaPitch));
        newTarget.z += z;
        return newTarget;
    }
    getCameraAngle() {
        var direc = store.state.viewer.navigation.getCamera().getWorldDirection();
        var direc2D = toPoint2D(direc);
        var upVec = new THREE.Vector3(0, 1, 0);
        var angle = THREE.Math.radToDeg(upVec.angleTo(direc2D));
        if (direc.x < 0)
            angle += (180 - angle) * 2;
        return angle;
    }
    //https://stackoverflow.com/questions/59385734/how-can-i-create-section-box-in-forge-viewer
    cropLevelIn3D(levels, isolateInNewViewer) {
        store.state.levels.forEach(o => o.isCropped = false);
        let allDbids = levels.filter(o => o.dbidsList && o.dbidsList.length > 0).flatMap(o => o.dbidsList)
        if (isolateInNewViewer && allDbids.length == 0) {
            store.dispatch({ type: "alert_Forge", message: 'No objects saved in level/s, please refresh it in admin page first.' })
            return;
        }
        if (isolateInNewViewer && allDbids.length > 0) {
            store.state.dbidsToLoad = allDbids
            store.commit('setIsIsolating3D', true);
            launchViewer(store.state.currentUrn, true)
            return;
        }
        if (levels.length == 0) {
            store.state.viewer.setCutPlanes(null);
            this.updateAll3DIcons();
            return;
        }

        levels.forEach(level => level.isCropped = true);

        const normals = [
            new THREE.Vector3(1, 0, 0),
            new THREE.Vector3(0, 1, 0),
            new THREE.Vector3(0, 0, 1),
            new THREE.Vector3(-1, 0, 0),
            new THREE.Vector3(0, -1, 0),
            new THREE.Vector3(0, 0, -1)
        ];

        let points = levels.map(o => o.getViewCropBox()).flatMap(o => [o.min, o.max]);
        let bbox = new THREE.Box3().setFromPoints(points)
        const cutPlanes = [];

        for (let i = 0; i < normals.length; i++) {
            const plane = new THREE.Plane(normals[i], -1 * bbox.max.dot(normals[i]));

            // offset plane with negative normal to form an octant
            if (i > 2) {
                const ptMax = plane.orthoPoint(bbox.max);
                const ptMin = plane.orthoPoint(bbox.min);
                const size = new THREE.Vector3().subVectors(ptMax, ptMin);
                plane.constant -= size.length();
            }

            const n = new THREE.Vector4(plane.normal.x, plane.normal.y, plane.normal.z, plane.constant);
            cutPlanes.push(n);
        }

        store.state.viewer.setCutPlanes(cutPlanes);

        var mainExtension = store.state.forgeService.getMainExtension();
        if (mainExtension._pointclouds) {
            var pointclouds = Array.from(mainExtension._pointclouds.values());
            if (pointclouds.length == 0)
                return;
            pointclouds.forEach(o => o.setClippingBoxNew(bbox));
        }

        //update cropped 3d icons
        this.updateAll3DIcons();
    }
    toggleShowingModel(model) {
        if (model.isLoading)
            return;
        if (model.isShown) {
            var models = store.state.viewer.impl.modelQueue().getModels();
            var forgeModel = models.find(o => o.getSeedUrn() == model.urn || o.getSeedUrn() + '==' == model.urn || o.getSeedUrn() + '=' == model.urn);
            store.state.viewer.impl.removeModel(forgeModel);
            model.isShown = false;
        } else {
            model.isLoading = true;
            checkIsModelTrasnlated(model.urn, (isTranslated, progress) => {
                if (!isTranslated) {
                    store.dispatch({
                        type: "alert_Forge",
                        message: 'Model translation in progress.' + progress
                    })
                    model.isLoading = false;
                    return;
                } else {
                    var state = store.state.viewer.getState({ viewport: true })
                    addViewable(store.state.viewer, model.urn, null, store.state.viewer.model.getGlobalOffset())
                        .then((m) => {
                            store.state.viewer.restoreState(state, { viewport: true }, true)
                            model.isLoading = false;
                            model.isShown = true;
                        })
                        .catch(error => {
                            console.log(error);
                            model.isLoading = false;
                        });

                }
            })
        }
    }
    textFileContentToImages(text, selectedFilesNames, scanType) {
        var result = [];
        if (scanType == 'faro') {
            var lines = text.split('{')[1].split('}')[0].split('\n');

            for (var i = 0; i < lines.length; i++) {

                var parts = lines[i].split(' ');
                if (parts.length < 10)
                    continue;
                var name = parts[0].split('"')[1];
                if (!selectedFilesNames.some(o => o == name))
                    continue;

                let imageRotation = Number.parseFloat(parts[7]);
                let easting = Number.parseFloat(parts[1]);
                let northing = Number.parseFloat(parts[2]);
                let elevation = Number.parseFloat(parts[3]);

                let rotationX = Number.parseFloat(parts[4]);
                let rotationY = Number.parseFloat(parts[5]);
                let rotationZ = Number.parseFloat(parts[6]);
                let img = new Image360();
                img.name = name;
                let date = parts[8].split('.')
                let time = parts[9].trim().split(':')
                img.createdOn = new Date(date[2], date[1], date[0], time[0], time[1], time[2]).toGMTString()
                img.createdBy = store.state.username;
                img.scanType = scanType;
                img.rotationX = rotationX;
                img.rotationY = rotationY;
                img.rotationZ = rotationZ;
                img.rotationAngle = imageRotation;
                // img.imageUrl = '../images/360-Panorama/' + name + ".jpg";
                img.isLocked = true;
                var rotation = axisAngleToEuler(rotationX, rotationY, rotationZ, imageRotation)

                img.lockedYaw = this.loadedFileAngleToYaw(rotation.z);
                img.lockedPitch = 0;//this.getPitch(rotationX,rotationY,rotationZ);
                img.forgeCameraPosition = new THREE.Vector3(easting, northing, elevation);
                img.lockedForgeDirection = Image360.getDefaultLockDirection();
                result.push(img);
            }
        } else if (scanType == 'leica') {
            lines = text.split('\n');
            for (let i = 1; i < lines.length; i += 4) {

                let name = lines[i];
                let translationLine = lines[i + 1];
                let rotationLine = lines[i + 2];
                if (!name || !translationLine || !rotationLine)
                    continue;
                name = name.split('\r')[0];
                if (!selectedFilesNames.some(o => o == name))
                    continue;

                if (!translationLine.startsWith('translation') || !rotationLine.startsWith('rotation'))
                    continue;
                let translationData = translationLine.split('(')[1].split(')')[0].split(',');
                let rotationString = rotationLine.split(':')[2].split(' ')[0];

                let imageRotation = Number.parseFloat(rotationString);
                let easting = Number.parseFloat(translationData[0]);
                let northing = Number.parseFloat(translationData[1]);
                let elevation = Number.parseFloat(translationData[2]);

                let rotationValues = rotationLine.split('(')[1].split(')')[0].split(',');
                let rotationX = Number.parseFloat(rotationValues[0]);
                let rotationY = Number.parseFloat(rotationValues[1]);
                let rotationZ = Number.parseFloat(rotationValues[2]);
                let img = new Image360();
                img.name = name;
                img.createdBy = store.state.username;
                img.createdOn = '';
                img.scanType = scanType;
                img.rotationX = rotationX;
                img.rotationY = rotationY;
                img.rotationZ = rotationZ;
                img.rotationAngle = imageRotation;
                // img.imageUrl = '../images/360-Panorama/' + name + ".jpg";
                img.isLocked = true;
                //based on discussion with Scott and Andy
                imageRotation -= 90;
                let rotation = axisAngleToEuler(rotationX, rotationY, rotationZ, imageRotation)

                img.lockedYaw = this.loadedFileAngleToYaw(rotation.z);
                img.lockedPitch = 0;//this.getPitch(rotationX,rotationY,rotationZ);
                img.forgeCameraPosition = new THREE.Vector3(easting, northing, elevation);
                img.lockedForgeDirection = Image360.getDefaultLockDirection();
                result.push(img);
            }
        } else if (scanType == 'geoslam') {
            let lines = text.split('\n');
            if (lines.length == 0)
                return result;
            for (let i = 1; i < lines.length; i++) {
                let parts = lines[i].split(',')
                let name = parts[0];
                if (name.endsWith('.jpg'))
                    name = name.slice(0, name.length - 4)
                if (!selectedFilesNames.some(o => o == name))
                    continue;
                //columns in csv
                //Image, Time, X, Y, Z, Heading, Roll, Pitch
                var imageRotation = Number.parseFloat(parts[5]);
                let yaw = imageRotation;
                if (imageRotation > 0) {
                    if (imageRotation < 90) {
                        yaw = -90 - imageRotation;
                    } else {
                        yaw = 180 - (imageRotation - 90)
                    }
                } else if (imageRotation < 0) {
                    if (imageRotation > -90) {
                        yaw = -90 + Math.abs(imageRotation)
                    } else {
                        yaw = Math.abs(imageRotation) - 90
                    }
                }
                var unixDate = Number.parseFloat(parts[1]);
                var easting = Number.parseFloat(parts[2]);
                var northing = Number.parseFloat(parts[3]);
                var elevation = Number.parseFloat(parts[4]);

                var rotationX = Number.parseFloat(parts[6]);
                var rotationY = Number.parseFloat(parts[7]);
                var rotationZ = 0;
                var img = new Image360();
                img.name = name;
                img.createdBy = store.state.username;
                img.createdOn = new Date(unixDate * 1000).toGMTString()
                img.scanType = scanType;
                img.rotationX = rotationX;
                img.rotationY = rotationY;
                img.rotationZ = rotationZ;
                img.rotationAngle = imageRotation;
                // img.imageUrl = '../images/360-Panorama/' + name + ".jpg";
                img.isLocked = true;
                img.lockedYaw = yaw;
                img.lockedPitch = 0;//this.getPitch(rotationX,rotationY,rotationZ);
                img.forgeCameraPosition = new THREE.Vector3(easting, northing, elevation);
                img.lockedForgeDirection = Image360.getDefaultLockDirection();
                result.push(img);
            }
        }
        return result;
    }
    getPitch(rotationX, rotationY, rotationZ) {
        var y = Math.abs(rotationZ);
        var x = new THREE.Vector2(rotationX, rotationY).distanceTo(new THREE.Vector2());
        var angle = Math.atan(y / x);
        return 90 - THREE.Math.radToDeg(angle);
    }
    loadedFileAngleToYaw(fileAngle) {
        if (fileAngle <= 180)
            return fileAngle;
        return - (360 - fileAngle);
    }
    getAllPanoramaImages() {
        var result = [];
        store.state.projects.forEach(project => {
            project.images.forEach(img => {
                result.push(img);
            });
        });
        return result;
    }
    getAllShownPanoramaImagesIn3D() {
        var result = [];
        store.state.projects.forEach(project => {
            project.images.forEach(img => {
                if (img.isVisibleInViewers && img.isLocked)
                    result.push(img);
            });
        });
        return result;
    }
    activatePersonMode() {
        store.state.viewer.getExtension('Autodesk.BimWalk').activate();
    }
    filterImagesByGlobalSearchText(images) {
        const GLOBAL_SEARCH_TAB_INDEX = 0;

        if (!store.state.isTabShown || store.state.selectedTab !== GLOBAL_SEARCH_TAB_INDEX) {
            return images;
        }
        const searchText = store.getters['GET_GLOBAL_SEARCH_TEXT'];
        if (!searchText) {
            return images;
        }
        return images.filter(img => store.state.filtered360Imgs.includes(img));
    }
    getTagsClustersAndItems(tags, cameraPosition3d, visibilityRange) {
        if (!store.state.selectedImage) return { items: [], clusters: [] };

        tags = tags.filter(i => i.point.distanceTo(cameraPosition3d) < visibilityRange);

        const positionsMap = new Map();
        for (let i = 0; i < tags.length; i++) {
            positionsMap.set(tags[i], tags[i].point);
        }

        let unitScale = store.state.viewer?.model?.getUnitScale() ?? 1.0

        let range = 5 / unitScale;

        const { clusters, separatedItems } = store.state.forgeService.getItemsClusters(tags, positionsMap, cameraPosition3d, range);

        return { items: separatedItems, clusters };
    }
    getItemsClusters(items, positionMap, cameraPosition, range = 5) {
        const processed = new Array(items.length).fill(false);
        const clusters = [];
        const separatedItems = [];

        items.sort((a, b) => a.point.distanceTo(b.point));

        for (let i = 0; i < items.length; i++) {
            if (processed[i]) continue;

            processed[i] = true;

            const currentItem = items[i];
            const closestItems = [currentItem];
            const itemPosition = positionMap.get(currentItem);

            if (itemPosition.distanceTo(cameraPosition) < range) {
                separatedItems.push(currentItem);
                continue;
            }

            const others = items.slice(i + 1).filter((o, j) => !processed[j + i + 1]);

            for (let j = 0; j < others.length; j++) {
                const closestItem = others[j];
                const closestPosition = positionMap.get(closestItem);
                if (itemPosition.distanceTo(closestPosition) < range * 10 && closestPosition.distanceTo(cameraPosition) > range) {
                    processed[j + i + 1] = true;
                    closestItems.push(closestItem);
                } else {
                    break;
                }
            }

            closestItems.length == 1 ? separatedItems.push(currentItem) : clusters.push(closestItems);
        }

        return { clusters, separatedItems };
    }
    groupImagesIntoBubbles(images, imagesWithPositionsMap, cameraPosition) {
        // If Image is already in the bubble process[i] == true.
        const processed = new Array(images.length).fill(false);
        const bubbles = [];
        const separatedImages = [];

        // Sort Images by their distance from the camera position.
        images.sort((a, b) => a.forgeCameraPosition.distanceTo(b.forgeCameraPosition));

        // Iterate through the images and add them to the bubble.
        for (let i = 0; i < images.length; i++) {
            // Already processed.
            if (processed[i]) continue;
            processed[i] = true;

            const currentImage = images[i];
            const closestImages = [currentImage];
            const imagePosition = imagesWithPositionsMap.get(currentImage);

            // Rest of the images that have't been processed.
            const others = images.slice(i + 1).filter((o, j) => !processed[j + i + 1]);

            for (let j = 0; j < others.length; j++) {
                // Zoomed in to the closest point;
                if (cameraPosition.z < 0.1) break;

                // If the condition is true then this the closestImg also processed and will add to the bubble.
                const closestImg = others[j];
                if (cameraPosition.z > 10 * imagePosition.distanceTo(imagesWithPositionsMap.get(closestImg))) {
                    processed[j + i + 1] = true;
                    closestImages.push(closestImg);
                } else {
                    break;
                }
            }

            if (closestImages.length == 1) {
                separatedImages.push(currentImage);
            } else {
                bubbles.push(closestImages);
            }
        }
        return { bubbles, separatedImages };
    }
    getBubblesAndImages(viewer, cameraPosition3d, visibilityRange) {
        if (!store.state.selectedLevel) return { images: [], bubbles: [] };
        const allImages = store.state.forgeService.getAllShownPanoramaImagesIn3D();
        let images = store.state.selectedLevel.filterImagesInside(allImages).filter(img => img.isLocked);
        images = store.state.forgeService.filterImagesByGlobalSearchText(images);

        // FilterBy visibilityRange 
        images = images.filter(i => i.forgeCameraPosition.distanceTo(cameraPosition3d) < visibilityRange);

        const imagesWithPositionsMap = new Map();
        for (let i = 0; i < images.length; i++) {
            const point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(images[i].forgeCameraPosition);
            imagesWithPositionsMap.set(images[i], point);
        }

        const cameraPosition = viewer.navigation.getPosition();
        const { bubbles, separatedImages } = store.state.forgeService.groupImagesIntoBubbles(images, imagesWithPositionsMap, cameraPosition);

        return { images: separatedImages, bubbles };
    }
    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    dateTimeNow() {
        return new Date().toISOString().slice(0, 19).replace('T', ' ');
    }
    getMainExtension() {
        if (!store.state.viewer) return null;

        let ex = store.state.viewer.getExtension('MainExtension');

        if (ex) return ex;

        store.state.viewer.loadExtension('MainExtension');

        return store.state.viewer.getExtension('MainExtension');
    }
    getMappingExtension3D() {
        return store.state.viewer?.getExtension('Mapping2d_3dExtension')
    }
    getMeasureExtensionInViewer3D() {
        if (!store.state.viewer)
            return null;
        return store.state.viewer.getExtension('MeasurementExtension');
    }
    getMeasureExtensionInViewer2D() {
        if (!store.state.planViewer)
            return null;
        return store.state.planViewer.getExtension('MeasurementExtension');
    }
    getCropping3DExtension() {
        return store.state.viewer.getExtension('Cropping3DExtension');
    }
    getScaffoldBoxExtension() {
        return store.state.viewer.getExtension('ScaffoldBoxExtension');
    }
    getDrawPointsExtension() {
        if (!store.state.planViewer)
            return null;
        return store.state.planViewer.getExtension('Plan2DExtension');
    }
    getLabels3DExtension() {
        if (!store.state.viewer)
            return null;
        return store.state.viewer.getExtension('labels3dExt');
    }
    getLabels2DExtension() {
        if (!store.state.planViewer)
            return null;
        return store.state.planViewer.getExtension('labels3dExt');
    }
    sortByTag(items) {
        items.sort((a, b) => a.name.localeCompare(b.name));
    }
    sortByName(items) {
        items.sort((a, b) => a.name.localeCompare(b.name, 'en-US', { numeric: "true" }));
    }
    getLevelContainsPoint(point) {
        for (var i = 0; i < store.state.levels.length; i++) {
            if (store.state.levels[i].containsElevation(point.z))
                return store.state.levels[i];
        }
        return null;
    }
    getTaggedItemsInLevel(level) {
        var result = [];
        for (var e = 0; e < store.state.tags.length; e++) {
            if (store.state.tags[e].level2D == level.name) {
                result.push(store.state.tags[e]);
                continue;
            }
            var center = store.state.tags[e].point;
            if (!center || center.z < level.bottomElevation || center.z > level.topElevation)
                continue;
            result.push(store.state.tags[e]);
        }
        return result;
    }
    getEquipmentsInLevel(level) {
        var result = [];

        var allEquipments = store.state.tags ?? [];
        for (var i = 0; i < allEquipments.length; i++) {
            var e = allEquipments[i];

            var center = e.point;

            if (!center) continue;

            if (e.level2D == level.name) {
                result.push(e);
                continue;
            }

            if (center.z < level.bottomElevation || center.z > level.topElevation) continue;

            result.push(e);
        }

        return result;
    }
    getAutoEquipmentsInLevel(level) {
        var result = [];

        var tags = store.getters['GET_ALL_EXISTING_AUTOMATIC_TAGS'];

        for (var i = 0; i < tags.length; i++) {
            var e = tags[i];

            var center = e.point;

            if (!center) continue;

            if (center.z < level.bottomElevation || center.z > level.topElevation) continue;

            result.push(e);
        }

        return result;
    }
    getManualStructuralTagsInLevel(level) {

        let result = [];

        let tags = store.getters.GET_MANUAL_STRUCTURAL_TAGS;

        for (let i = 0; i < tags.length; i++) {
            let center = tags[i].point;
            if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
            result.push(tags[i]);
        }

        return result;
    }
    getStructuralTagsInLevel(level) {
        let result = [];
        let tags = store.getters.GET_ALL_EXISTING_STRUCTURAL_TAGS
        for (let i = 0; i < tags.length; i++) {
            let center = tags[i].point;
            if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
            result.push(tags[i]);
        }
        return result;
    }
    getManualPipelineTagsInLevel(level) {

        let result = [];
        let tags = store.getters.GET_MANUAL_PIPELINES_TAGS;

        for (let i = 0; i < tags.length; i++) {
            let center = tags[i].point;
            if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
            result.push(tags[i]);
        }

        return result;
    }
    getPipelineTagsInLevel(level) {
        let result = [];
        let tags = store.getters.GET_ALL_EXISTING_PIPELINES_TAGS
        for (let i = 0; i < tags.length; i++) {
            let center = tags[i].point;
            if (center.z < level.bottomElevation || center.z > level.topElevation) continue;
            result.push(tags[i]);
        }
        return result;
    }
    getAnnotationsInLevel(level) {
        if (!level) return [];

        var result = [];
        for (var i = 0; i < store.state.annotations.length; i++) {
            if (store.state.annotations[i].level2D == level.name) {
                result.push(store.state.annotations[i]);
                continue;
            }

            var center = store.state.annotations[i].point;
            if (center.z < level.bottomElevation || center.z > level.topElevation)
                continue;
            result.push(store.state.annotations[i]);
        }
        return result;
    }
    getInspectionsInLevel(level, inspections) {
        if (!inspections) inspections = store.state.inspections;

        var result = [];
        for (var i = 0; i < inspections.length; i++) {
            var center = inspections[i].point;

            if (!center) continue;

            if (inspections[i].level2D == level.name) {
                result.push(inspections[i]);
                continue;
            }

            if (center.z < level.bottomElevation || center.z > level.topElevation)
                continue;
            result.push(inspections[i]);
        }
        return result;
    }
    getScaffoldsInLevel(level) {
        var result = [];
        for (var i = 0; i < store.state.scaffolds.length; i++) {
            var center = store.state.scaffolds[i].position;
            if (center.z < level.bottomElevation || center.z > level.topElevation)
                continue;
            result.push(store.state.scaffolds[i]);
        }
        return result;
    }
    getTagsInfoData(tagsInfo) {
        let result = [];
        let ids = []

        var equipmentIds = tagsInfo.filter(o => o.type == 'tag');
        var annotationIds = tagsInfo.filter(o => o.type == 'annotation');
        var inspectionIds = tagsInfo.filter(o => o.type == 'inspection');
        var scaffoldIds = tagsInfo.filter(o => o.type == 'permit' || o.type == 'scaffold' || o.type == 'container');

        result = store.state.tags.reduce((acc, item) => {
            let e = equipmentIds.find(i => i.id == item.id);
            if (e && item.children?.length) {
                ids.push(...item.children.map(i => i.dbId));
                e.children = item.children.map(c => c.dbId);
                acc.push(e);
            }
            return acc;
        }, result);

        result = store.state.TAGS.allExistingAutomaticDbids.reduce((acc, item) => {
            let e = equipmentIds.find(i => i.id == item.id);
            if (e) {
                ids.push(item.dbid);
                e.children = [item.dbid];
                acc.push(e);
            }
            return acc;
        }, result);

        result = store.state.annotations.reduce((acc, item) => {
            let e = annotationIds.find(i => i.id == item.id);
            if (e && item.children?.length) {
                ids.push(...item.children.map(i => i.dbId));
                e.children = item.children.map(c => c.dbId);
                acc.push(e);
            }
            return acc;
        }, result);

        result = store.state.inspections.reduce((acc, item) => {
            let e = inspectionIds.find(i => i.id == item.id);
            if (e && item.children?.length) {
                ids.push(...item.children.map(i => i.dbId));
                e.children = item.children.map(c => c.dbId);
                acc.push(e);
            }
            return acc;
        }, result);

        result = store.state.scaffolds.reduce((acc, item) => {
            let e = scaffoldIds.find(i => i.id == item.id);
            if (e && item.children?.length) {
                ids.push(...item.children.map(i => i.dbId));
                e.children = item.children.map(c => c.dbId);
                acc.push(e);
            }
            return acc;
        }, result);

        return { tagsInfo: result, dbIds: ids };
    }
    showTagsByIdsWithColorAndAnimation(tagsInfo, options) {
        if (!store.state.viewer) return;

        let result = store.state.forgeService.getTagsInfoData(tagsInfo);

        store.commit('SET_THEMED_DB_IDS', result.dbIds);

        result.tagsInfo.forEach(item => {
            if (item.color && item.children) {
                let color = new THREE.Color(item.color);
                color = new THREE.Vector4(color.r, color.g, color.b, 1);
                let dbIds = item.children;
                setPermeativeElementsTheme(dbIds, color);
            }
        });

        store.state.forgeService.getMainExtension().showDbIdsWithAnimation(result.dbIds, options);
    }
    showTagsByIds(tagsInfo) {
        if (!store.state.viewer)
            return;

        var equipmentIds = tagsInfo.filter(o => o.type == 'tag').map(o => parseInt(o.id))
        var annotationId = tagsInfo.find(o => o.type == 'annotation')?.id
        var inspectionId = tagsInfo.find(o => o.type == 'inspection')?.id
        var scaffoldId = tagsInfo.find(o => o.type == 'permit' || o.type == 'scaffold' || o.type == 'container')?.id
        var tags = store.state.tags.filter(o => equipmentIds.includes(o.id));
        var automaticTags = store.state.TAGS.allExistingAutomaticDbids.filter(o => equipmentIds.includes(o.id))

        if (tags.length > 0 || automaticTags.length > 0) {
            var normalDbIds = tags.filter(o => o.children).flatMap(o => o.children.map(o => o.dbId));
            let autoDbIds = automaticTags.filter(o => o.dbid).map(t => t.dbid);
            this.getMainExtension().isolateDbIds(normalDbIds.concat(autoDbIds));
            return;
        }

        if (annotationId) {
            annotationId = parseInt(annotationId)
            let annotation = store.state.annotations.find(o => annotationId == o.id);
            if (annotation) {
                this.zoomToAnnotation(annotation, true);
                return;
            }
        }

        if (inspectionId) {
            inspectionId = parseInt(inspectionId)
            let inspection = store.state.inspections.find(o => inspectionId == o.id);
            if (inspection) {
                this.zoomToAnnotation(inspection, true);
                return;
            } else {
                let amisInspection = store.state.TAGS.allExistingAMISDbids.find(t => t.id == inspectionId);

                if (amisInspection && amisInspection.children) {
                    let dbIds = amisInspection.children.map(o => o.dbId);
                    this.getMainExtension().isolateDbIds(dbIds);
                    return;
                }
            }
        }

        if (scaffoldId) {
            scaffoldId = parseInt(scaffoldId)
            var scaffold = store.state.scaffolds.find(o => scaffoldId == o.id);
            if (scaffold) {
                this.zoomToTagOrScaffold(scaffold, true);
            }
        }
    }
    zoomToItem(item) {
        this.getLabels3DExtension()?.createHighlightingTags([item]);

        let fitToView = !store.state.selectedImage;

        if (item instanceof ForgeAnnotation || item instanceof ForgeInspection)
            this.zoomToAnnotation(item, fitToView);
        else if (item instanceof ForgeScaffold)
            this.zoomToTagOrScaffold(item, fitToView);
        else this.isolateTag(item, fitToView);
    }
    zoomToPoint2D(point) {
        let min = new THREE.Vector3(point.x - 1, point.y - 1, 0);
        let max = new THREE.Vector3(point.x + 1, point.y + 1, 0);

        min = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(min);
        max = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(max);
        var bubbleBox = new THREE.Box3(min, max);
        store.state.planViewer.navigation.fitBounds(false, bubbleBox);
    }
    isolateTag(tag, fitToView = true) {
        if (!store.state.viewer) {
            store.dispatch({
                type: "alert_Forge",
                message: 'Please open 3d viewer first.'
            })
            return;
        }

        var dbids = tag.getAllDbIds();
        //send model if tag is model tag to isolate
        let model = null;
        if (tag.tagHarvesterId && tag.children[0].urn)
            model = store.state.viewer.getAllModels().find(o => o.getSeedUrn() == tag.children[0].urn);

        fitToView ? this.getMainExtension()?.isolateDbIds(dbids, model) : this.getMainExtension()?.isolateDbIdsWithoutFitView(dbids, model);
    }
    getPointCloudContainsImage(image) {
        let project = store.state.projects.find(o => o.images.find(i => i.id == image.id));

        if (project) {
            let projectPointCloud = store.state.pointClouds.find(o => o.name == project.name);

            if (projectPointCloud) return projectPointCloud;
        }

        let level = store.state.levels.find(level => level.isImageInsideLevel(image));

        if (level) {
            let levelPointCloud = store.state.pointClouds.find(o => o.name == level.name);

            if (levelPointCloud) return levelPointCloud;
        }

        return null;
    }
    toggleShowingPointCloudIn3D(model) {
        store.state.forgeService.setShowingPointCloudIn3D(model, !model.isShown);
    }
    setShowingPointCloudIn3D(model, value) {
        if (store.state.viewer) {
            model.isShown = value;

            if (model.isShown) {
                if (store.state.pointClouds.every(o => o.isShown))
                    store.state.userSettings.displaySettings.pointCloudDisplay.showPointClouds = true;
            }
            else {
                if (store.state.pointClouds.every(o => !o.isShown))
                    store.state.userSettings.displaySettings.pointCloudDisplay.showPointClouds = false;
            }

            store.state.forgeService.getMainExtension().showPointCloud(model.name, model.isShown, model.url);
        }
    }
    cacheFragsPerMaterials() {
        if (!store.state.viewer?.model) return;

        if (this.fragIdPerMaterial)
            return;
        this.fragIdPerMaterial = {};
        const tree = store.state.viewer.model.getInstanceTree();
        const frags = store.state.viewer.model.getFragmentList();
        for (let i = 0; i < this.allForgeElements.length; i++) {
            const dbid = this.allForgeElements[i].dbId;
            tree.enumNodeFragments(
                dbid,
                (fragid) => {
                    this.fragIdPerMaterial[fragid] = frags.getMaterial(fragid);
                },
                true
            );
        }
    }
    resetObjectsMaterials() {
        if (!this.fragIdPerMaterial) return;

        const tree = store.state.viewer.model.getInstanceTree();

        if (!tree) return;

        const frags = store.state.viewer.model.getFragmentList();

        for (let i = 0; i < this.allForgeElements.length; i++) {
            const dbid = this.allForgeElements[i].dbId;
            tree.enumNodeFragments(
                dbid,
                (fragid) => {
                    var mat = this.fragIdPerMaterial[fragid];
                    if (mat) {
                        frags.setMaterial(fragid, mat)
                        store.state.viewer.model.unconsolidate();
                    }
                },
                true
            );
        }
    }
    updateMaterialToGray() {
        this.grayMaterial = createGrayMaterial(store.state.viewer, "MODS_GrayMaterial");
        this.cacheFragsPerMaterials();
        var toggleOn = store.state.isGreyModel ?? false;
        const tree = store.state.viewer.model.getInstanceTree();
        const frags = store.state.viewer.model.getFragmentList();
        for (let i = 0; i < this.allForgeElements.length; i++) {
            const dbid = this.allForgeElements[i].dbId;
            tree.enumNodeFragments(dbid, (fragid) => {
                var mat = toggleOn ? this.grayMaterial : this.fragIdPerMaterial[fragid];
                if (mat) {
                    frags.setMaterial(fragid, mat)
                    store.state.viewer.model.unconsolidate();
                }
            }, true);
        }
    }
    updateModelGray() {
        if (store.state.isGreyModel) {
            if (!this.ThemingStack.includes(0)) this.ThemingStack.push(0);
            store.state.forgeService.updateMaterialToGray();
        }
        else {
            if (this.ThemingStack.includes(0)) this.ThemingStack = this.ThemingStack.filter(o => o !== 0);
            store.state.forgeService.resetObjectsMaterials();
        }

        store.state.forgeService.updateGhosting();

        store.state.viewer.impl.invalidate(true, true, true)
    }
    updateGhosting(fitViewer = true) {
        // Prepare data.
        store.state.forgeService.cacheFragsPerMaterials();
        const mainExt = this.getMainExtension();
        if (!mainExt) return;

        const grayModel = store.state.isGreyModel ?? false;
        const toggleOn = store.state.isGhostingOn;
        const isGhostingWireframe = store.state.isGhostingWireframe;
        const isolatedDbids = mainExt.isolatedDbids ?? [];
        const tree = store.state.viewer.model.getInstanceTree();
        const frags = store.state.viewer.model.getFragmentList();
        const isolatedDbidsPrimitive = isolatedDbids.flatMap(o => getNodeChildDbidsForNode(o, tree));

        // Check ghosting:
        if (!toggleOn) {
            // If ghosting is off, then isolate the selected elements and reset the theming colors
            store.state.viewer.isolate(isolatedDbids, store.state.viewer.model);

            // There is a previous ghosting mode, so we need to reset the materials
            const modeIsGhosted = this.ThemingStack.some(o => o);
            if (modeIsGhosted) {
                if (isGhostingWireframe) {
                    store.state.viewer.setGhosting(false);
                }
                else {
                    this.grayMaterial ??= createGrayMaterial(store.state.viewer, "MODS_GrayMaterial");
                    this.updateFragmentMaterials(store.state.viewer, tree, frags, isolatedDbidsPrimitive, () => grayModel, this.grayMaterial);
                }

                this.ThemingStack = this.ThemingStack.filter(o => !o); // Remove all ghosting modes from the stack
            }
        } else {
            // If ghosting is on
            if (isGhostingWireframe) {
                store.state.viewer.setGhosting(false);

                // If wireframe is on, then isolate the selected elements and set the ghosting to true
                this.isolateAndGhost(store.state.viewer, isolatedDbids, fitViewer, toggleOn);

                if (!this.ThemingStack.includes(1)) {
                    this.ThemingStack = this.ThemingStack.filter(o => o !== 2);
                    this.ThemingStack.push(1);
                }
            } else {
                // If wireframe is off, show all elements and set the correct material to elements
                store.state.viewer.setGhosting(false);

                store.state.viewer.isolate([]);

                this.ghostingMaterial = createMaterial(store.state.viewer, "MODS_GhostingMaterials", store.state.ghostingColor, true);

                this.updateFragmentMaterials(store.state.viewer, tree, frags, this.allForgeElements.map(d => d.dbId), (dbId) => !isolatedDbidsPrimitive.includes(dbId), this.ghostingMaterial);

                if (grayModel) {
                    this.updateFragmentMaterials(store.state.viewer, tree, frags, isolatedDbidsPrimitive, () => grayModel, this.grayMaterial);
                }

                if (!this.ThemingStack.includes(2)) {
                    this.ThemingStack = this.ThemingStack.filter(o => o !== 1);
                    this.ThemingStack.push(2);
                }
            }
        }

        this.updateThemingColors(store.state.viewer, this.dbIdPerThemingColor);

        store.state.viewer.impl.invalidate(true, true, true);
    }

    isolateAndGhost(viewer, isolatedDbids, fitViewer, toggleOn) {
        isolateForge(viewer, viewer.model, isolatedDbids, fitViewer);
        viewer.setGhosting(toggleOn);
    }

    updateFragmentMaterials(viewer, tree, frags, dbids, condition, conditionalMaterial) {
        for (const dbid of dbids) {
            tree.enumNodeFragments(
                dbid,
                fragid => {
                    const mat = condition(dbid, fragid) ? conditionalMaterial : this.fragIdPerMaterial[fragid];
                    if (mat) {
                        frags.setMaterial(fragid, mat);
                        viewer.model.unconsolidate();
                    }
                },
                true
            );
        }
    }

    updateThemingColors(viewer, themingColors) {
        for (const [key, value] of Object.entries(themingColors)) {
            if (value) {
                viewer.setThemingColor(key, value, null, true);
            }
        }
    }

    cameraZoomOutByScaler(scaler) {
        var nav = store.state.viewer.navigation

        var pos = nav.getPosition()

        var target = nav.getTarget()

        var viewDirection = new THREE.Vector3()

        viewDirection.subVectors(pos, target).normalize()

        viewDirection.multiplyScalar(scaler)

        pos.add(viewDirection)

        nav.setPosition(pos)
    }
    getTargetImageIfAvailable(element) {
        let linked360ImageInfo = element.linked360ImageInfo;
        let closestImage = null;

        if (this.panoramaViewer) {
            if (linked360ImageInfo) {
                closestImage = store.state.projects.flatMap(o => o.images).find(img => img.id == linked360ImageInfo.imageId);
            } else {
                closestImage = this.getClosestImageToPoint(element.getPointInView());
            }

            // else if (viewer) {
            //     closestImage = this.getClosestImageToPoint(element.getPointInView());
            // } else {
            //     closestImage = store.state.selectedImage
            // }
        }

        return closestImage;
    }
    ZoomToDbIdsIn3D(dbIds) {
        if (!store.state.viewer) {
            store.dispatch({
                type: "alert_Forge",
                message: 'Please open 3d viewer first.'
            })
            return;
        }

        if (dbIds.length == 0) {
            store.dispatch({
                type: "alert_Forge",
                message: 'No inspection to zoom in.'
            })
            return;
        }

        let bbox = getBBBox(dbIds);

        this.getMainExtension()?.isolateDbIdsWithoutFitView(dbIds);

        this.zoomToPoint3dViewer(bbox);
    }
    /**
     * Zooms in all available viewers to the specified element.
     *
     * @param {Object} element - The element to zoom in to.
     * @param {Boolean} isolate - Whether or not to isolate the element in the viewer.
     */
    zoomInAllAvailableViewers(element, isolate) {
        // Check if the element is null.
        if (!element) {
            console.log('❌ element is null.');
            return;
        }

        // Create highlighting tags for the element in the 3D viewer.
        this.getLabels3DExtension()?.createHighlightingTags([element]);

        // Get the point and target to zoom in on.
        let point = element instanceof ForgeScaffold ? element.position : element.point; // Normal point.
        let target = element.getPointInView(); // Mapped point to 3d.

        // Zoom in to the point in the 2D viewer if it exists.
        if (store.state.planViewer) {
            store.dispatch('zoomToPointIn2D', {
                point3d: point,
                levelName: element.level2D,
                callback: () => {
                    store.state.forgeService.getLabels2DExtension()?.createHighlightingTags([element]);
                }
            });
        }

        // Get the closest image if the panorama viewer exists.
        let closestImage = this.panoramaViewer ? store.state.forgeService.getTargetImageIfAvailable(element) : null;

        // Check if the closest image is already opened.
        let isAlreadyOpened = closestImage != null && (store.state.selectedImage == closestImage);

        let bbox = null;

        // Isolate the element in the viewer if it has children and isolate is true.
        if (isolate && store.state.viewer && element.children?.length) {
            var dbids = element.children.map(o => o.dbId);
            this.getMainExtension()?.isolateDbIdsWithoutFitView(dbids);
            bbox = getBBBox(dbids);
        }

        // Zoom in to the 3D and 360 viewer if they both exist.
        if (store.state.viewer && this.panoramaViewer) {
            if (isAlreadyOpened) {
                store.state.forgeService.zoomToPoint3dViewer(target);
                store.state.forgeService.zoomToPointIn360Viewer(point, () => {
                    setTimeout(() => {
                        store.state.forgeService.linkViewers();
                    }, 100);
                });
            } else {
                this.launchPanoViewer(closestImage);
                this.zoomToPointIn360Viewer(point);
                this.zoomToPoint3dViewer(target);
            }

            store.state.forgeService.linkViewers(true);
        }
        // Zoom in to the 3D viewer if it exists.
        else if (store.state.viewer) {
            this.zoomToPoint3dViewer(bbox ?? target);
        }
        // Zoom in to the 360 viewer if it exists.
        else if (this.panoramaViewer) {
            if (isAlreadyOpened) {
                this.zoomToPointIn360Viewer(point);
            } else {
                this.launchPanoViewer(closestImage);
                this.zoomToPointIn360Viewer(point);
            }
        }
    }
    zoomToTagOrScaffold(element, animate) {
        let linked360ImageInfo = element.linked360ImageInfo;
        let closestImage = null;

        if (this.panoramaViewer) {
            if (linked360ImageInfo) {
                closestImage = store.state.projects.flatMap(o => o.images).find(img => img.id == linked360ImageInfo.imageId);
            } else if (store.state.viewer) {
                closestImage = this.getClosestImageToPoint(element.getPointInView());
            } else {
                closestImage = store.state.selectedImage
            }
        }

        let isAlreadyOpended = store.state.selectedImage != null && (store.state.selectedImage == closestImage);

        let point = element instanceof ForgeScaffold ? element.position : element.point;
        let target = element.getPointInView();

        if (store.state.viewer && this.panoramaViewer && store.state.areViewsLocked && linked360ImageInfo) {
            if (isAlreadyOpended) {
                this.zoomToPointIn3DAnd360(target);
            } else {
                this.launchPanoViewer(closestImage);
                this.zoomToPointIn360Viewer(point);
                this.zoomToPoint3dViewer(target);
            }
        } else if (store.state.viewer || this.panoramaViewer) {
            if (store.state.viewer) {
                if (!linked360ImageInfo) {
                    if (element instanceof ForgeScaffold) {
                        let box = element.getBox();
                        store.state.viewer.navigation.fitBounds(!closestImage, box);
                    } else {
                        this.isolateTag(element, !closestImage);
                    }
                } else {
                    this.zoomToPoint3dViewer(target);
                }
            }

            if (this.panoramaViewer) {
                if (isAlreadyOpended) {
                    this.zoomToPointIn360Viewer(point);
                } else {
                    this.launchPanoViewer(closestImage);
                    this.zoomToPointIn360Viewer(point);
                }
            }
        } else {
            store.dispatch({
                type: "alert_Forge",
                message: 'Please open 3D viewer first.'
            })
        }

    }
    zoomToAnnotation(annotation, animate) {

        if (store.state.viewer && annotation.children && annotation.children.length > 0) {
            var dbids = annotation.children.map(o => o.dbId);
            this.getMainExtension().isolateDbIds(dbids);
            return
        }

        // annotation in 2D
        if (annotation.level2D && (!store.state.planViewer || annotation.level2D != store.state.selectedLevel.name)) {

            let level = store.state.levels.find(l => l.name == annotation.level2D)

            if (level && level.planUrn) {
                store.dispatch("showLevel", { level: level });
                store.commit("setLoad2dViewerCallback", () => {
                    let point = level.mappingViewersPointsInfo._3dTo2d(annotation.point);
                    store.state.forgeService.zoomToPoint2dViewer(point);
                });
            } else {
                store.dispatch({
                    type: "alert_Forge",
                    message: `Please open 2d viewer first, level "${annotation.level2D}".`
                })
            }

            return;
        }

        if (store.state.planViewer) {
            let showenIn2d = false;

            if (annotation instanceof ForgeInspection) {
                showenIn2d = store.state.forgeService.getInspectionsInLevel(store.state.selectedLevel).includes(annotation);
            } else {
                showenIn2d = store.state.forgeService.getAnnotationsInLevel(store.state.selectedLevel).includes(annotation);
            }

            if (showenIn2d) {
                let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(annotation.point);
                store.state.forgeService.zoomToPoint2dViewer(point)
            } else {
                let level = store.state.forgeService.getLevelContainsPoint(annotation.point);

                if (level) {
                    store.dispatch("showLevel", { level: level });
                    store.commit("setLoad2dViewerCallback", () => {
                        let point = level.mappingViewersPointsInfo._3dTo2d(annotation.point);
                        store.state.forgeService.zoomToPoint2dViewer(point);
                    });
                } else if (!store.state.forgeService.panoramaViewer || store.state.viewer) {
                    store.dispatch({
                        type: "alert_Forge",
                        message: 'Please open 3d viewer first'
                    })
                }
            }
        }

        if (!annotation.point) return;

        let closestImage = null;

        if (store.state.forgeService.panoramaViewer) {
            let linked360ImageInfo = annotation.linked360ImageInfo;

            if (linked360ImageInfo) {
                closestImage = store.state.projects.flatMap(o => o.images).find(img => img.id == linked360ImageInfo.imageId);
            } else if (store.state.viewer) {
                closestImage = store.state.forgeService.getClosestImageToPoint(annotation.getPointInView());
            } else {
                closestImage = store.state.selectedImage
            }
        }

        let isAlreadyOpended = store.state.selectedImage != null && (store.state.selectedImage == closestImage);

        // 3d opened, 360 are opened
        if (store.state.forgeService.panoramaViewer && store.state.viewer) {
            let target = annotation.getPointInView();

            setTimeout(() => {
                if (isAlreadyOpended) {
                    if (store.state.areViewsLocked) {
                        store.state.forgeService.zoomToPointIn3DAnd360(target);
                    } else {
                        store.state.forgeService.zoomToPoint3dViewer(target);
                        store.state.forgeService.zoomToPointIn360Viewer(annotation.point);
                    }
                } else {
                    store.state.forgeService.launchPanoViewer(closestImage);
                    store.state.forgeService.zoomToPointIn360Viewer(annotation.point);
                    store.state.forgeService.zoomToPoint3dViewer(target);
                }
            }, 100);
        } else if (store.state.viewer) {
            let target = annotation.getPointInView();
            store.state.forgeService.zoomToPoint3dViewer(target);
        } else if (store.state.forgeService.panoramaViewer) {
            if (isAlreadyOpended) {
                store.state.forgeService.zoomToPointIn360Viewer(annotation.point);
            } else {
                store.state.forgeService.launchPanoViewer(closestImage);
                store.state.forgeService.zoomToPointIn360Viewer(annotation.point);
            }
        }
    }
    // target = annotation.getPointInView();
    zoomToPointIn3DAnd360(target, callback) {
        let isLinkedViewers = store.state.areViewsLocked

        if (!store.state.viewer || !store.state.forgeService.panoramaViewer || !isLinkedViewers) return false;

        store.state.viewer.navigation.setTarget(target);

        let fov = store.state.forgeService.panoramaViewer.getHfovBounds();
        let minFOV = fov[0];
        let maxFOV = fov[1];

        let zoom = (minFOV + maxFOV) / 2;

        store.state.forgeService.panoramaViewer.setHfov(zoom, false);

        store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(zoom));

        if (callback) callback();

        return true;
    }
    // point = annotation.point
    zoomToPointIn360Viewer(point, callback) {
        let selectedImage = store.state.selectedImage;

        if (!selectedImage || !store.state.forgeService.panoramaViewer) return false;

        let dir = point.clone().sub(selectedImage.forgeCameraPosition).normalize()

        var info = store.state.forgeService.getNewYawAndPitch(selectedImage, dir);

        let fov = store.state.forgeService.panoramaViewer.getHfovBounds();
        let minFOV = fov[0];
        let maxFOV = fov[1];

        let zoom = (minFOV + maxFOV) / 4;

        store.state.forgeService.panoramaViewer.lookAt(info['pitch'], info['yaw'], zoom, 0);

        if (callback) callback();

        return true;
    }
    // target = annotation.getPointInView();
    zoomToPoint3dViewer(target, callback) {
        if (!store.state.viewer?.model) return;

        let box = null;

        if (target instanceof THREE.Box3) {
            box = target;
        } else {
            let offset = 1 / store.state.viewer.model.getUnitScale();
            let min = new THREE.Vector3(target.x - offset, target.y - offset, target.z - offset);
            let max = new THREE.Vector3(target.x + offset, target.y + offset, target.z + offset);
            box = new THREE.Box3(min, max);
        }

        store.state.viewer.navigation.fitBounds(true, box);

        if (callback) callback();
    }
    // point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(annotation.point);
    zoomToPoint2dViewer(point, callback) {
        let min = new THREE.Vector3(point.x - .01, point.y - .01, point.z - .01);
        let max = new THREE.Vector3(point.x + .01, point.y + .01, point.z + .01);
        var box = new THREE.Box3(min, max);
        store.state.planViewer.navigation.fitBounds(false, box);

        if (callback) callback();
    }
    take3dPointScreenshot(point, callback) {
        var state = store.state.viewer.getState();

        store.state.forgeService.zoomToPoint3dViewer(point)

        setTimeout(() => {
            takeScreenshot(store.state.viewer, base64 => {
                if (callback) callback(base64);
                store.state.viewer.restoreState(state);
            })
        }, 100);
    }
    deleteScaffolds(scaffolds) {
        saveScaffolds(scaffolds, editType.DELETE_SCAFFOLDS);
        for (let i = 0; i < scaffolds.length; i++) {
            var index = store.state.scaffolds.findIndex(o => o.id == scaffolds[i].id);
            store.state.scaffolds.splice(index, 1);
        }
        this.update3dIconsInAllViews();
    }
    uploadAttachment(file, parentId, parentType, callback) {
        this.isUploading = true;
        let formData = new FormData();
        formData.append("fileToUpload", file, file.name);
        formData.append("assetName", store.state.assetId);
        formData.append("parentId", parentId);
        formData.append("createdBy", store.state.username);
        formData.append("parentType", parentType);

        const ctrl = new AbortController() // timeout
        setTimeout(() => ctrl.abort(), 5000);

        HttpService.post({
            url: 'api/forge/attachments/uploadAttachment',
            data: formData,
            signal: ctrl.signal,
            headers: {
                'Content-Type': false,
                'processData': false,
            }
        }).then(response => {
            let attachment = Object.assign(new ForgeAttachment(), response.data);
            callback(attachment);
        }).catch(err => {
            store.dispatch({
                type: "alert_Forge",
                message: err
            })
        }).finally(() => {
            this.isUploading = false;
        });

        $('#uploadAttachmentFile').val('');
    }
    addSubInspection(point) {
        store.commit('setIsPickingSubTag', false);
        let editingTag = store.getters['GET_EDITING_TAG']
        if (!editingTag || !(editingTag instanceof ForgeInspection))
            return;
        if (!editingTag.level2D && !store.state.viewer) {
            store.dispatch({
                type: "alert_Forge",
                message: 'Please open 3D viewer first.'
            })
            return;
        }
        store.dispatch({
            type: "prompt_Forge",
            title: "Add Sub Inspection", callback: name => {
                let newSubTag = new ForgeInspectionSubTag();
                newSubTag.name = name;
                newSubTag.point = point;

                editingTag.subTags.push(newSubTag);
            }, input: {
                inputName: "Name",
                inputValue: ''
            }
        })

    }
    zoomToSubInspection(subTag, inspection) {
        var min, max;
        if (!inspection.level2D) {
            let point = subTag.getPointInView();
            min = new THREE.Vector3(point.x - 1, point.y - 1, point.z - 1);
            max = new THREE.Vector3(point.x + 1, point.y + 1, point.z + 1);
        } else {
            let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(subTag.point);
            min = new THREE.Vector3(point.x - .01, point.y - .01, point.z - .01);
            max = new THREE.Vector3(point.x + .01, point.y + .01, point.z + .01);
        }
        var box = new THREE.Box3(min, max);
        let v = inspection.level2D ? store.state.planViewer : store.state.viewer;
        v.navigation.fitBounds(false, box);
    }

    deleteAttachment(attachments, callback) {
        store.dispatch({
            type: "confirm_Forge",
            message: 'Are you sure you want to remove attachment?', callback: () => {
                let info = {
                    'assetId': store.state.assetId,
                    'attachments': attachments
                }

                HttpService.post({
                    url: 'api/forge/attachments/deleteAttachments',
                    data: info
                }).then(response => {
                    callback();
                }).catch(err => {
                    console.log(err)
                    store.dispatch({
                        type: "alert_Forge",
                        message: err
                    })
                });
            }
        })
    }

    downloadMarkup(markup) {
        var url = markup.imageUrl ? markup.imageUrl : markup.pdfUrl;
        downloadURI(url, markup.name);
    }
    filterLevelsBySearch(projects, search) {
        var canFilterElementByText = function (text, image) {
            if (image.name != null && image.name.toLowerCase().trim().includes(text))
                return true;
            return false;
        }
        projects.forEach(o => o.setAllImagesVisable(true));
        if (!search || search == '')
            return projects;
        var lower = search.toLowerCase().trim();
        projects.forEach(project => {
            project.isVisable = false;
            project.images.forEach(img => {
                if (canFilterElementByText(lower, img)) {
                    project.isExpanded = true;
                    project.isVisable = true;
                    img.isVisable = true;
                } else
                    img.isVisable = false;
            });
        });
        return projects;
    }

    crop3D(point) {
        setTimeout(() => {
            store.commit('setIsPickingCropOrigin', false);
            let extension = store.state.forgeService.getCropping3DExtension();
            extension.cropBoxOrigin = point;

            store.commit('setShowCroppingBoxPopup', true);
        }, 50);

    }
    getPointInView(point) {
        if (!point || (!store.state.viewer?.model && !store.state.unitScale))
            return point;

        if (!(point instanceof THREE.Vector3)) {
            point = new THREE.Vector3(point.x, point.y, point.z);
        }

        return store.state.forgeService.worldToView3d(point, point)
    }
    worldToView3d(point, defaultValue) {
        if (!point || ((!store.state.viewer || !store.state.viewer.model) && !store.state.unitScale)) return defaultValue;

        return point.clone().multiplyScalar(1 / store.state.unitScale).sub(store.state.globalOffset)
    }
    view3dToWorld(point) {
        return point.clone().add(store.state.globalOffset).multiplyScalar(store.state.unitScale);
    }
    view3dToWorldLength(length) {
        return length * store.state.unitScale
    }
    worldToView3dLength(length) {
        return length / store.state.unitScale
    }
    //thumbnail popups
    onClickOn3dIcon(item, event, type) {
        if (store.getters["GET_IS_MEASUREING"]) return;

        let url = item instanceof Image360 ? item.thumbnailURL : item.thumbnailUrl;
        let x = event ? event.offsetX + 50 : "calc(50% - 130px)";
        let y = event ? event.offsetY - 50 : "calc(50% - 120px)";

        store.commit('setThumnailPopupInfo',
            {
                type: type,
                info: {
                    item: item,
                    shown: true,
                    imgUrl: url,
                    x: x,
                    y: y
                }
            });
    }
    showListOfThumbnails(items, event, type) {
        if (store.getters["GET_IS_MEASUREING"]) return;

        let x = event ? event.offsetX + 50 : "calc(50% - 130px)";
        let y = event ? event.offsetY - 50 : "calc(50% - 120px)";

        store.commit('setThumnailPopupInfo', { type: type, info: { items: items, shown: true, showContext: true, x: x, y: y } });
    }
    updatePopupItemsForTag(tag) {
        let popup2dInfo = store.getters['get2dThumbnailPopupInfo']
        if (popup2dInfo && popup2dInfo.item && popup2dInfo.item.id == tag.id) {
            popup2dInfo.item = tag
            popup2dInfo.imgUrl = tag.thumbnailUrl
        }
        let popup3dInfo = store.getters['get3dThumbnailPopupInfo']
        if (popup3dInfo && popup3dInfo.item && popup3dInfo.item.id == tag.id) {
            popup3dInfo.item = tag
            popup3dInfo.imgUrl = tag.thumbnailUrl
        }
        let popup360Info = store.getters['get360ThumbnailPopupInfo']
        if (popup360Info && popup360Info.item && popup360Info.item.id == tag.id) {
            popup360Info.item = tag
            popup360Info.imgUrl = tag.thumbnailUrl
        }
    }
    startWaitingForPickingCropOrigin() {
        store.commit('setIsPickingCropOrigin', true);
    }

    toggleTagArea2dCommand(tag) {
        if (!store.state.planViewer) {
            store.dispatch({ type: "alert_Forge", message: 'Please open 2d viewer first.' })
            return;
        }
        if (!store.state.selectedLevel) {
            store.dispatch({ type: "alert_Forge", message: 'Please open a level first.' })
            return;
        }
        if (!store.state.selectedLevel.hasAllMappingInfo()) {
            store.dispatch({ type: "alert_Forge", message: 'Please finish mapping 2d/3d in admin first.' })
            return;
        }
        if (tag.area2dCoordinates)
            tag.area2dCoordinates = null;
        else
            store.state.forgeService.getDrawPointsExtension().setTagToAddAreaTo(tag);
    }
    toggleCreatingAreaToDownloadPC() {
        if (!store.state.planViewer) {
            store.dispatch({ type: "alert_Forge", message: 'Please open 2d viewer first.' })
            return;
        }
        if (!store.state.selectedLevel) {
            store.dispatch({ type: "alert_Forge", message: 'Please open a level first.' })
            return;
        }
        if (!store.state.selectedLevel.hasAllMappingInfo()) {
            store.dispatch({ type: "alert_Forge", message: 'Please finish mapping 2d/3d in admin first.' })
            return;
        }

        let value = store.getters["getIsDrawingAreaToDownloadPC"];
        store.dispatch('toggleAreaToDownloadPC', { value: !value });
        store.state.forgeService.getDrawPointsExtension().setDrawingMode(!value);
    }
    sendDataToDownloadPointCloudTab(polygonPoints) {
        let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == 0;
        let allImages = store.state.projects.flatMap(o => o.images);
        var images = store.state.selectedLevel.filterImagesInside(allImages).filter(o => o.isLocked);
        if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
            images = images.filter(o => store.state.filtered360Imgs.includes(o));
        }

        let results = [];

        images.forEach(image => {
            let inside = isPointInsidePolygon(image.forgeCameraPosition, polygonPoints)
            if (inside) results.push(image);
        })

        store.commit('setImagesInCropbox', results);

        store.state.mainApp.showPanel(9);
        store.state.mainApp.isLeftMenuPinned = true;
    }
    getAutomaticTagsByIds(ids, callback) {
        return new Promise((resolve, reject) => {
            postData(`api/equipments/getAutomaticTagsByIds`, ids,
                result => {
                    result.equipments = result.equipments.map(e => {
                        let autoTag = Object.assign(new ForgeEquipment(), e);
                        autoTag.parseContent()
                        return autoTag;
                    })

                    store.dispatch('PUSH_TAGS_TO_AUTOMATIC_TAGS', { tags: result.equipments });

                    if (callback) callback(result.equipments);

                    resolve(result.equipments);
                },
                error => {
                    console.log(error);
                    reject(error);
                })
        })
    }
    // viewType => "3d", "2d", "360"
    addNewTag(viewType, tagPoint, level2D, canAddScaffold) {
        let is3D = viewType == "3d";

        let isTreeLoaded = store.state.isTreeLoaded;
        if (is3D && !isTreeLoaded) {
            store.dispatch({ type: "alert_Forge", message: 'Please wait for forge to load data.' })
            return;
        }

        if (!is3D && !level2D) {
            store.commit('setIsPickingTag', false)
        }

        store.state.mainApp.showPanel(4, true);
        let selection = is3D ? store.state.viewer.getSelection() : [];

        store.dispatch('CLEAR_PREVIOUS_TAGS');
        store.commit('SET_EDITING_TAG', null);
        store.commit('SET_ADDING_TAG_INFO', {
            name: '',
            viewType: viewType,
            tagPoint: tagPoint,
            level2D: level2D,
            selection: selection,
            type: canAddScaffold ? 'Equipment' : 'General',
            canAddScaffold: canAddScaffold
        });
    }
    createTagFromSelection() {
        setTimeout(() => {
            if (!store.state.isPickingTag) return;
            let selection = store.state.viewer.getSelection();
            let point = this.view3dToWorld(getBBBox(selection).getCenter())
            this.addNewTag('3d', point, null, true);
            store.commit('setIsPickingTag', false)
        }, 50);
    }
    editForgTagElement(elem) {
        store.state.mainApp.showPanel(4, true);
        store.dispatch('CLEAR_PREVIOUS_TAGS');
        store.commit('SET_EDITING_TAG', elem.clone());
        store.commit('setLastSelectedTagId', elem.id);
        store.state.forgeService.updateAll3DIcons();
    }
    showEditScaffoldUI(scaffold) {
        store.state.mainApp.showPanel(4, true);
        store.dispatch('CLEAR_PREVIOUS_TAGS');
        store.commit('SET_EDITING_TAG', scaffold.clone());
        store.commit('setLastSelectedTagId', scaffold.id);
        store.state.forgeService.updateAll3DIcons();
    }
    showEditAnnotationUI(annotation) {
        store.state.mainApp.showPanel(4, true);
        store.dispatch('CLEAR_PREVIOUS_TAGS');
        store.commit('SET_EDITING_TAG', annotation.clone());
        store.commit('setLastSelectedTagId', annotation.id);
        store.state.forgeService.updateAll3DIcons();
    }
    showEditTagUI(tag) {
        store.state.mainApp.showPanel(4, true);
        store.dispatch('CLEAR_PREVIOUS_TAGS');
        store.commit('SET_EDITING_TAG', tag.clone());
        store.commit('setLastSelectedTagId', tag.id);
        store.state.forgeService.updateAll3DIcons();
    }
    showEditInspectionUI(tag) {
        store.state.mainApp.showPanel(11, true);
        store.commit('SET_EDITING_AMIS_TAG', tag.clone());
        store.commit('setLastSelectedTagId', tag.id);
    }
    showEditAMISUI(tag) {
        store.state.mainApp.showPanel(11, true);
        store.dispatch('CLEAR_PREVIOUS_TAGS');
        store.commit('SET_EDITING_AMIS_TAG', tag.clone());
        store.commit('setLastSelectedTagId', tag.id);
        store.state.forgeService.updateAll3DIcons();
    }
    openTagInActivityManager(tag) {
        var type = 'tag';
        if (tag instanceof ForgeAnnotation)
            type = 'annotation';
        else if (tag instanceof ForgeScaffold)
            type = 'scaffold';
        else if (tag instanceof ForgeInspection)
            type = 'inspection';

        if (!store.getters['getIsRealityActivityManagerShown'])
            store.state.mainApp.selectActivityViewOption(2);

        let isTabShown = store.state.isTabShown;
        ForgeMessage.sendMessageToParent('pick-tag', { pickedTagId: tag.id, type: type, fullWidth: !isTabShown })
    }
    fillLevelsDbids(viewer, callback) {
        if (!viewer || !viewer.model)
            return;
        getAllLeafComponents(viewer.model, (dbIds) => {
            let allObjects = []
            dbIds.forEach(dbId => {
                let box = getBBBox([dbId], viewer.model);
                let center = box.getCenter()
                allObjects.push({ dbId: dbId, center: center })
            })
            store.state.levels.forEach(level => {
                let levelBox = level.getViewCropBox();
                level.dbidsList = allObjects.filter(o => levelBox.containsPoint(o.center)).map(o => o.dbId)
            })
            if (callback)
                callback()
        });
    }
    getTagById(id) {
        return store.getters['getAllTags'].find(o => o.id == id)
    }
    updateAllLinkedTagsWithTagLinks(updatedTag) {
        let existingTag = this.getTagById(updatedTag.id);

        let dbLinks = existingTag ? existingTag.linkedTagsList ?? [] : [];

        let newLinks = updatedTag.linkedTagsList ?? [];

        //add new added links
        for (let i = 0; i < newLinks.length; i++) {
            const id = newLinks[i];

            if (dbLinks.includes(id)) continue;

            let tag = this.getTagById(id);

            if (!tag) continue;

            let links = tag.linkedTagsList ?? [];

            if (!links.includes(updatedTag.id)) {
                tag.createNewLink(updatedTag.id)
            }
        }

        //remove deleted link
        for (let i = 0; i < dbLinks.length; i++) {
            const id = dbLinks[i];

            if (newLinks.includes(id)) continue;

            let tag = this.getTagById(id);

            if (!tag || tag.linkedTagsList == null) continue;

            let links = tag.linkedTagsList ?? [];

            tag.removeLinkedTag(updatedTag.id);
        }
    }
    deleteTagLinksFromOtherTags(tag) {
        let links = tag.linkedTagsList != null ? tag.linkedTagsList : [];
        if (links.Count == 0)
            return;
        //add new added links
        for (let i = 0; i < links.length; i++) {
            const id = links[i];
            let linked = this.getTagById(id);
            if (!linked)
                continue;
            let linksIds = linked.linkedTagsList;
            if (linksIds == null)
                linksIds = [];
            let index = linksIds.indexOf(tag.id)
            linksIds.splice(index, 1);
            linked.linkedTagsList = linksIds;
        }
    }
    deleteAllTagsLinks(tags) {
        tags.forEach(removedTag => {
            let links = removedTag.linkedTagsList;

            for (let i = 0; i < links.length; i++) {
                const id = links[i];

                let tag = this.getTagById(id);

                if (!tag) continue;

                tag.removeLinkedTag(removedTag.id);
            }
        })
    }

    //3d icons    
    update3dIconsInAllViews() {
        this.updateAll3DIcons();
        this.updateAll2DIcons();
        if (this.panoramaViewer) {
            this.updateTagsAnnotationsInPanoViewer();
            this.update360ImagesHotspots();
        }
    }
    updateAll3DIcons() {
        if (!store.state.viewer || !store.state.viewer.model)
            return;
        let labelEx = this.getLabels3DExtension()
        if (labelEx) {
            labelEx.update360Images();
            labelEx.updateTags();
        }
        this.updateScaffoldin3D();
    }
    updateTagsIconsIn3D() {
        if (!store.state.viewer || !store.state.viewer.model)
            return;
        let labelEx = this.getLabels3DExtension()
        if (labelEx) {
            labelEx.update360Images();
            labelEx.updateTags();
        }
    }
    clearAll3D_2DIcons() {
        if (store.state.viewer && store.state.viewer.model) {
            this.getLabels3DExtension().clear360ImagesIcons();
            this.getLabels3DExtension().clear3DTags();
            store.state.viewer.impl.invalidate(true);
        }
        let labels2DEx = this.getLabels2DExtension();
        if (labels2DEx) {
            labels2DEx.clear360ImagesIcons();
            labels2DEx.clear3DTags();
            store.state.planViewer.impl.invalidate(true);
        }
    }
    updateAll2DIcons() {
        if (!store.state.planViewer || !this.getLabels2DExtension())
            return;
        this.getLabels2DExtension().update360Images();
        this.getLabels2DExtension().updateTags();
    }
    updateScaffoldin3D() {
        let ext = store.state.forgeService.getScaffoldBoxExtension();

        if (ext) {
            ext.update();
        }
    }
    updateListWithEditingTag(list) {
        let isReadOnly = store.getters['GET_IS_TAG_READ_ONLY'];

        if (!isReadOnly) {
            let _tag = store.getters['GET_EDITING_TAG'];

            if (_tag && list.length && _tag.constructor === list[0].constructor) {
                list = [...list.filter(o => o.id !== _tag.id), _tag];
            }
        }

        isReadOnly = store.getters['GET_IS_AMIS_TAG_READ_ONLY'];

        if (!isReadOnly) {
            let _tag_amis = store.getters['GET_EDITING_AMIS_TAG'];

            store.state.forgeService.updateAMISTagsColors([_tag_amis]);

            if (_tag_amis && list.length && _tag_amis.constructor === list[0].constructor) {
                list = [...list.filter(o => o.id !== _tag_amis.id), _tag_amis];
            }
        }

        return list;
    }
    addCategoryColorToLabel(categoryName, label) {
        if (!categoryName)
            return;
        let category = store.state.categories.find(o => o.name == categoryName);
        if (!category)
            return;
        let categCircle = document.createElement('div');
        categCircle.style.width = '13px';
        categCircle.style.height = '13px';
        categCircle.style.borderRadius = '10px';
        categCircle.style.marginLeft = '5px';
        categCircle.style.backgroundColor = category.color;
        label.appendChild(categCircle);
    }
    clearElementsByClassName(className) {
        let labels = document.getElementsByClassName(className);
        while (labels.length > 0) {
            labels[0].parentNode.removeChild(labels[0]);
        }
    }
    create3DIconToViewer(options) {
        let worldPosition = options.position;
        let width = options.width;
        let height = options.height;
        let rotation = options.rotation;
        let differences = options.differences;
        let title = options.title;
        let id = options.id;
        let className = options.className;
        let forgeViewer = options.forgeViewer;
        let onClick = options.onClick;
        let addContent = options.addContent;
        let removeTildeSign = options.removeTildeSign;
        let metadata = options.metadata;

        if (worldPosition == null) return;

        let label = document.createElement('div');
        label.setAttribute('data-id', id);
        label.setAttribute('data-x', worldPosition.x);
        label.setAttribute('data-y', worldPosition.y);
        label.setAttribute('data-z', worldPosition.z);
        if (width) label.setAttribute('data-width', width);
        if (height) label.setAttribute('data-height', height);
        if (rotation) label.setAttribute('data-rotation', rotation);
        if (metadata) label.setAttribute('data-metadata', metadata);
        label.title = title;
        label.className = className;
        label.onclick = onClick;
        let elem = forgeViewer.container;
        if (!elem) return;
        elem.appendChild(label);

        if (addContent) {
            let textDiv = document.createElement('div');
            textDiv.innerHTML = `<span>${removeTildeSign ? '' : '~ '}${title}</span>`;
            textDiv.className = 'tag-title dimension-text';
            label.appendChild(textDiv);
            const clientPosition = forgeViewer.worldToClient(worldPosition);

            if (width && height) {
                const worldCornerNW = new THREE.Vector3(worldPosition.x - width / 2, worldPosition.y + height / 2, 0);
                const worldCornerSE = new THREE.Vector3(worldPosition.x + width / 2, worldPosition.y - height / 2, 0);
                const clientCornerNW = forgeViewer.worldToClient(worldCornerNW);
                const clientCornerSE = forgeViewer.worldToClient(worldCornerSE);
                const clientWidth = Math.abs(clientCornerNW.x - clientCornerSE.x);
                const clientHeight = Math.abs(clientCornerNW.y - clientCornerSE.y);
                label.setAttribute('data-clientwidth', clientWidth);
                label.setAttribute('data-clientheight', clientHeight);
                label.style.width = `${clientWidth}px`;
                label.style.height = `${clientHeight}px`;
            }

            label.style.left = `${Math.floor(clientPosition.x - label.offsetWidth / 2)}px`;
            label.style.top = `${Math.floor(clientPosition.y - label.offsetHeight / 2)}px`;
            if (rotation) label.style.rotate = `${rotation}rad`;

            if (differences != null) {
                let divTextX = document.createElement('div');
                divTextX.innerHTML = `<span>X</span> <span>${differences.x}</span>`;
                divTextX.className = 'tag-title text-diff-x';
                label.appendChild(divTextX);

                let divTextY = document.createElement('div');
                divTextY.innerHTML = `<span>Y</span> <span>${differences.y}</span>`;
                divTextY.className = 'tag-title text-diff-y';
                label.appendChild(divTextY);

                if (differences.z) {
                    let divTextZ = document.createElement('div');
                    divTextZ.innerHTML = `<span>Z</span> <span>${differences.z}</span>`;
                    divTextZ.className = 'tag-title text-diff-z';
                    label.appendChild(divTextZ);
                }
            }
        }
        return label;
    }
    updateLabelsPositionsByClassName(className, forgeViewer) {
        let labels = document.getElementsByClassName(className);
        for (let i = 0; i < labels.length; i++) {
            let label = labels[i];
            const worldPosition = new THREE.Vector3(parseFloat(label.getAttribute('data-x')),
                parseFloat(label.getAttribute('data-y')), parseFloat(label.getAttribute('data-z')));
            const clientPosition = forgeViewer.worldToClient(worldPosition);

            let width = parseFloat(label.getAttribute('data-width'));
            let height = parseFloat(label.getAttribute('data-height'));

            if (width && height) {
                const worldCornerNW = new THREE.Vector3(worldPosition.x - width / 2, worldPosition.y + height / 2, 0);
                const worldCornerSE = new THREE.Vector3(worldPosition.x + width / 2, worldPosition.y - height / 2, 0);
                const clientCornerNW = forgeViewer.worldToClient(worldCornerNW);
                const clientCornerSE = forgeViewer.worldToClient(worldCornerSE);
                const clientWidth = Math.abs(clientCornerNW.x - clientCornerSE.x);
                const clientHeight = Math.abs(clientCornerNW.y - clientCornerSE.y);
                label.setAttribute('data-clientwidth', clientWidth);
                label.setAttribute('data-clientheight', clientHeight);
                label.style.width = `${clientWidth}px`;
                label.style.height = `${clientHeight}px`;
            }

            //position label in the center of the box
            label.style.left = `${Math.floor(clientPosition.x - label.offsetWidth / 2)}px`;
            label.style.top = `${Math.floor(clientPosition.y - label.offsetHeight / 2)}px`;
            label.style.rotate = `${label.getAttribute('data-rotation')}rad`;

        }
    }
    toggleCrossHairCursorToViewer(isToggleOn, viewer) {
        if (isToggleOn)
            viewer.canvas.style.cursor = 'crosshair'
        else
            viewer.canvas.style.cursor = 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABHVBMVEUAAABPTk4AAAAAAAAJCQkRERE0MzQQEBAODg4QEBB4d3dbWlo9PDw/Pj4vLy8sLCwZGBgWFhYcHBwKCgoSEhIAAAAKCgoICAgKCgoQEBAODg4EBAQICAgPDw8REREMDAx2dnY0NDQvLy9QUFAaGhomJSYjIyM7OjokJCQNDA0mJiYNDQ0AAAAUFBQJCQkQEBAEBAQNDQ0PDw8VFRX///+amJkAAAD5+fnz8/PKycn9/f339vbi4eLR0dDNzMyAgIB8e3xycHH7+/vw7+/o6OjX1ta7urq4t7iwsLCnp6eioqKbmppva21OTk74+Pjl5eXc3Nzb29vLy8vDw8PDwsKrqqqdnZ2WlpaSkpKTkZKMiouEg4NkZGRISEgxLzBpgbsEAAAANHRSTlMA+fiQXgngKSYG/vX17uvBuqackpCNg3BpUkpAPBwTDvj18+vl0s/NwrOwoZZ+TDg4NBkBGrzX8QAAAP5JREFUKM99j9Vuw0AQRdeuKZyGkyZNmbnXDLHDVGb8/8/oy7paK1bO0+oc7WiGnGiaxq+QRTQAOh8f9Jv4H/Ge8PZPrCdlvkxfYluUT2WyyCq3mZ7unwlKVLcqOzA/Mf71j0TWJ/Ym6rPeca05Ni4iIevYc7yoUD2zQFhq71BdI9nvBeBabFDSPe8DswlUc1Riw3VxbH0NHBUPQ0jrbDnPYDjALQBMq9E7nkC5y7VDKTZlUg8Q0lmjvl74zlYErgvKa42GPKf3/a0kQmYCDY1SYMDosqMoiWrGwz/uAbNvc/fNon4kXRKGq+PUo2Mb96afV0iUxqGU2s4VBbKUP65NL/LKF+7ZAAAAAElFTkSuQmCC"),auto'
    }

    //Admin
    getForgeModels(assetId, callback) {
        if (!assetId) return null;
        HttpService.get({
            url: `api/assets/fetchAdminModel/?assetId=${assetId}`,
        }).then(response => {
            callback(response.data);
        }).catch(error => {
            console.error(error)
        });
    }
    saveMasterModel(assetId, modelName) {
        let encoded = encodeURIComponent(modelName);
        HttpService.post({
            url: `api/assets/editSelectedModel?assetId=${assetId}&selectedModel=${encoded}`,
            data: null,
        }).then(response => {
            console.log('Saved selected Model');
        }).catch(error => {
            console.log(error)
        });
    }
    saveSelectedLevel(assetId, levelName) {
        let encoded = encodeURIComponent(levelName);
        HttpService.post({
            url: `api/assets/editSelectedLevel?assetId=${assetId}&selectedLevel=${encoded}`,
            data: null,
        }).then(response => {
            console.log('Saved selected Level');
        }).catch(error => {
            console.log(error)
        });
    }
    deleteVersion(assetId, urn, callback) {
        HttpService.delete({
            url: `api/forge/oss/objects?assetId=${assetId}&urn=${urn}&isSmallModel=false`,
        }).then(response => {
            callback();
        }).catch(error => {
            console.log(error)
        });
    }
    saveSettings(assetId, settings, callback) {
        HttpService.post({
            url: `api/forge/settings/saveSettings`,
            data: {
                assetId: assetId,
                settings: settings
            },
        }).then(response => {
            callback();
        }).catch(error => {
            console.log(error)
        });
    }
    saveUserSettings(callback) {
        HttpService.post({
            url: `api/forge/settings/saveUserSettings`,
            data: store.state.userSettings,
        }).then(response => {
            callback();
        }).catch(error => {
            console.log(error)
        });
    }
    uploadFileInChunks(file, assetId, versionInfo, onProgress) {
        return new Promise((resolve, reject) => {
            const chunkSize = 1024 * 1024 * 100; // 100 MB
            const fileSize = file.size;
            const chunks = Math.ceil(fileSize / chunkSize);
            let chunk = 0;
            let result = null;
            const uploadId = store.state.forgeService.generateUniqueId();

            function chunkUpload() {
                const start = chunk * chunkSize;
                const end = Math.min(fileSize, (chunk + 1) * chunkSize);
                const chunkFile = file.slice(start, end);
                const formData = new FormData();
                formData.append("fileToUpload", chunkFile);
                formData.append("assetId", assetId.toString());
                formData.append("isSmallModel", 'false');
                formData.append("isSvf2", versionInfo.isSvf2);
                formData.append("name", versionInfo.name);
                formData.append("version", versionInfo.version);
                formData.append("userUpdated", store.state.username);

                const xhr = new XMLHttpRequest();
                xhr.upload.addEventListener("progress", (evt) => {
                    if (evt.lengthComputable) {
                        onProgress(start + evt.loaded, fileSize);
                    }
                }, false);
                xhr.addEventListener("load", () => {
                    if (xhr.status === 200) {
                        result = xhr.responseText;
                        if (++chunk < chunks) {
                            chunkUpload();
                        } else {
                            resolve(JSON.parse(result));
                        }
                    } else {
                        reject(xhr.statusText);
                    }
                });
                xhr.addEventListener("error", () => {
                    reject(xhr.statusText);
                });
                xhr.addEventListener("abort", () => {
                    reject("Upload cancelled.");
                });
                xhr.open("POST", config.API_URL + "api/assets/uploadModelChunks", true);
                xhr.setRequestHeader("Authorization", getAuthHeaders().Authorization);
                xhr.setRequestHeader("Upload-Id", uploadId);
                xhr.setRequestHeader("File-Name", file.name);
                xhr.setRequestHeader("Chunk-Number", chunk + 1);
                xhr.setRequestHeader("Total-Chunks", chunks);
                xhr.send(formData);
            }

            chunkUpload();
        });
    }

    uploadFile(assetId, versionInfo, file, onProgress, callback) {
        let formData = new FormData();
        formData.append("fileToUpload", file);
        formData.append("assetId", assetId.toString());
        formData.append("isSmallModel", 'false');
        formData.append("isSvf2", versionInfo.isSvf2);
        formData.append("name", versionInfo.name);
        formData.append("version", versionInfo.version);
        formData.append("userUpdated", store.state.username);
        // const ctrl = new AbortController()    // timeout
        // setTimeout(() => ctrl.abort(), 5000);
        HttpService.post({
            url: `api/assets/uploadModel`,
            data: formData,
            //signal: ctrl.signal,
            headers: {
                'Content-Type': false,
                'processData': false,
            },
            onUploadProgress: function (progressEvent) {
                if (progressEvent.event.lengthComputable) {
                    onProgress(progressEvent.loaded, progressEvent.total);
                }
            }
        }).then(response => {
            callback(response.data)
        }).catch(error => {
            console.log(error)
        });
    }

    getAllTagsForModelByAssetId(assetId) {
        return HttpService.get({
            url: "api/tags/getAllHarvestedTagsByAssetId",
            params: {
                assetId: assetId
            }
        })
        .then((response) => response.data)
        .catch(error => console.error(error.message));
    }

    uploadVersionToAsset(uploadInChunks, assetId, versionInfo, file, onProgress, callback, onError) {
        if (uploadInChunks) {
            store.state.forgeService.uploadFileInChunks(file, assetId, versionInfo, onProgress)
                .then((result) => {
                    if (callback) callback(result);
                })
                .catch((error) => {
                    console.log(error);
                    if (onError) onError(error);
                });
        } else {
            store.state.forgeService.uploadFile(assetId, versionInfo, file, onProgress, callback);
        }
    }

    generateUniqueId() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let id = '';
        for (let i = 0; i < 10; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }

    //Azure storage
    getClientURL(containerName, sasToken, callBack) {
        HttpService.get({
            url: `api/blobStorage/getSasToken`,
        }).then(response => {
            const token = response.token
            const url = `${store.state.pointCloudContainer}?${token.token}`;
            const containerClient = new ContainerClient(url, new AnonymousCredential());
            callBack(containerClient);
        }).catch(error => {
            console.log(error)
        });
    }

    uploadPointCloud(files, pointCloudName, assetId, onProgress, onCloudJsFileUploaded) {
        this.getClientURL(async containerClient => {

            let pcFileCount = 0;
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                if (file.name == 'cloud.js' || file.name == 'metadata.json')
                    pcFileCount++;
            }

            if (pcFileCount == 0) {
                store.dispatch({
                    type: "alert_Forge",
                    message: 'File cloud.js OR metadata.json not found.'
                })
                return;
            }
            if (pcFileCount > 1) {
                store.dispatch({
                    type: "alert_Forge",
                    message: 'Found more than one instance of cloud.js || metadata.json'
                })
                return;
            }

            let newGuid = this.newGuid();
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                let fileName = `${assetId}/pointClouds/${newGuid}-${file.webkitRelativePath}`;
                const blockBlobClient = await containerClient.getBlockBlobClient(fileName);
                await blockBlobClient.uploadData(file, {
                    onProgress: (ev) => {
                        onProgress();
                    }
                });

                //if cloud.js => save to mongo / add to point cloud list
                if (file.name == 'cloud.js' || file.name == 'metadata.json') {
                    let cloudJsUrl = `${store.state.pointCloudContainer}/${fileName}`
                    this.uploadPointCloudjsFile(cloudJsUrl, assetId, pointCloudName, pointCloudModel => {
                        onCloudJsFileUploaded(pointCloudModel);
                    });
                }

            }
        });
    }

    // getClientURL(callBack) {
    //     HttpService.get({
    //         url: `api/blobStorage/getSasToken`,
    //     }).then(response => {
    //         let token = response.token
    //         let url = `${store.state.pointCloudContainer}?${token.token}`;
    //         const containerURL = new azblob.ContainerURL(url, azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));
    //         callBack(containerURL);
    //     }).catch(error => {
    //         console.log(error)
    //     });
    // }

    // uploadPointCloud(files, pointCloudName, assetId, onProgress, onCloudJsFileUploaded) {

    //     this.getClientURL(async containerURL => {

    //         let pcFileCount = 0;
    //         for (let i = 0; i < files.length; i++) {
    //             let file = files[i];
    //             if (file.name == 'cloud.js' || file.name == 'metadata.json')
    //                 pcFileCount++;
    //         }

    //         if (pcFileCount == 0) {
    //             store.dispatch({
    //                 type: "alert_Forge",
    //                 message: 'File cloud.js OR metadata.json not found.'
    //             })
    //             return;
    //         }
    //         if (pcFileCount > 1) {
    //             store.dispatch({
    //                 type: "alert_Forge",
    //                 message: 'Found more than one instance of cloud.js || metadata.json'
    //             })
    //             return;
    //         }

    //         let newGuid = this.newGuid();
    //         for (let i = 0; i < files.length; i++) {
    //             let file = files[i];
    //             let fileName = `${assetId}/pointClouds/${newGuid}-${file.webkitRelativePath}`;
    //             const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, fileName);
    //             await azblob.uploadBrowserDataToBlockBlob(azblob.Aborter.none, file, blockBlobURL).then(o => {
    //                 onProgress();
    //             });
    //             //if cloud.js => save to mongo / add to point cloud list
    //             if (file.name == 'cloud.js' || file.name == 'metadata.json') {
    //                 let cloudJsUrl = `${store.state.pointCloudContainer}/${fileName}`
    //                 await this.uploadPointCloudjsFile(cloudJsUrl, assetId, pointCloudName, pointCloudModel => {
    //                     onCloudJsFileUploaded(pointCloudModel);
    //                 });
    //             }

    //         }
    //     });
    // }

    uploadPointCloudjsFile(url, assetId, name, callback) {
        let formData = new FormData();
        formData.append("assetId", assetId.toString());
        formData.append("name", name);
        formData.append("cloudJsUrl", url);

        const ctrl = new AbortController()    // timeout
        setTimeout(() => ctrl.abort(), 5000);

        HttpService.post({
            url: `api/upload/pointCloud/cloudjsFile`,
            data: formData,
            headers: {
                'Content-Type': false,
                'processData': false,
            }
        }).then(response => {
            callback(response.data);
        }).catch(error => {
            console.log(error)
        });
    }
    addPointCloudUrlToMongo(assetId, name, url, callback) {
        let data = { 'assetId': assetId, 'name': name, 'url': url, 'user': store.state.username };
        const ctrl = new AbortController()    // timeout
        setTimeout(() => ctrl.abort(), 5000);
        HttpService.post({
            url: `api/mongo/addPointCloudUrl`,
            data: data,
        }).then(response => {
            callback(response.data);
        }).catch(error => {
            console.log(error)
        });
    }
    addPointCloudFolder(assetId, url, callback) {
        let data = { 'assetId': assetId, 'url': url, 'user': store.state.username };
        const ctrl = new AbortController()    // timeout
        setTimeout(() => ctrl.abort(), 5000);
        HttpService.post({
            url: `api/forge/addPointCloudFolder`,
            data: data,
        }).then(response => {
            callback(response.data);
        }).catch(error => {
            console.log(error)
        });
    }
    deletePointCloud(pointCloudModel, onProgress, onDone) {
        let _this = this;
        this.getClientURL(async (containerClient) => {
            let pointCloudUrl = decodeURIComponent(pointCloudModel.url);
            pointCloudUrl = pointCloudUrl.replace(store.state.pointCloudContainer + '/', '');
            let endWordLength = pointCloudUrl.endsWith('/cloud.js') ? '/cloud.js'.length : '/metadata.json'.length;
            pointCloudUrl = pointCloudUrl.substring(0, pointCloudUrl.length - endWordLength);
            let options = {
                prefix: pointCloudUrl
            };
            let marker = undefined;
            do {
                const listBlobsResponse = await containerClient.listBlobsFlat(options);
                marker = listBlobsResponse.nextMarker;
                const items = listBlobsResponse.segment.blobItems;
                let doneFiles = 0;
                onProgress(doneFiles, items.length);
                for await (const blob of containerClient.listBlobsFlat(options)) {
                    await containerClient.deleteBlob(blob.name);
                    doneFiles++;
                    onProgress(doneFiles, items.length);
                }

                _this.deletePointCloud_Mongo(pointCloudModel.id, () => {
                    onDone();
                });

            } while (marker);
        });
    }
    deletePointCloud_Mongo(id, callback) {
        HttpService.post({
            url: `api/mongo/delete/pointCloud?id=${id}`,
            data: null,
        }).then(response => {
            callback(response.data);
        }).catch(error => {
            console.log(error)
        });
    }
    deletePointClouds(ids) {
        HttpService.post({
            url: `api/pointClouds/deleteAll`,
            data: { ids: ids }
        }).then(response => {
            console.log(response.data);
        }).catch(error => {
            console.log(error)
        });
    }
    openNearest360ToPoint(point, callback) {
        if (!store.state.viewer) return;

        let isImageLoaded = false;

        let closestImage = store.state.forgeService.getClosestImageToPoint(point);

        if (closestImage) {
            if (!store.state.forgeService.panoramaViewer) {
                store.state.mainApp.openViewPageWithType('360');
            } else {
                store.state.mainApp.showViewPageWithType('360');
            }
            setTimeout(() => {
                if (closestImage != store.state.selectedImage) {
                    store.state.forgeService.launchPanoViewer(closestImage);
                    if (store.state.viewer) store.state.forgeService.navigateIn3D(closestImage);
                } else {
                    isImageLoaded = true;
                }

                if (callback) callback(isImageLoaded);
            }, 100);
        }
    }
    openNearest360ToTag(tag, callback) {
        let closestImage = null;
        let linked360ImageInfo = tag.linked360ImageInfo;

        let openClosetImage = () => {
            if (closestImage) {
                if (!store.state.forgeService.panoramaViewer) {
                    store.state.mainApp.openViewPageWithType('360');
                } else {
                    store.state.mainApp.showViewPageWithType('360');
                }
                setTimeout(() => {
                    if (closestImage != store.state.selectedImage) {
                        store.commit('setLoad360ViewerCallback', () => {
                            if (callback) callback();
                        })

                        store.state.forgeService.launchPanoViewer(closestImage);

                        if (store.state.viewer) store.state.forgeService.navigateIn3D(closestImage);
                    } else {
                        if (callback) callback();
                    }
                }, 100);
            }
        }

        if (linked360ImageInfo) {
            closestImage = store.state.projects.flatMap(o => o.images).find(img => img.id == linked360ImageInfo.id);
        } else {
            closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
        }

        // else if (viewer) {
        //     // let point = tag instanceof ForgeScaffold ? tag.position : tag.point;
        //     closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
        // } else if (store.state.selectedImage) {
        //     debugger
        //     closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
        // } else {
        //     store.commit("setShowLoading", true);

        //     let index = mainApp.openViewPageWithType('3d');

        //     let isModelLoaded = () => viewer?.model?.getInstanceTree();

        //     waitForValue(isModelLoaded, 60000)
        //         .then(() => {
        //             closestImage = store.state.forgeService.getClosestImageToPoint(tag.getPointInView());
        //             dispose3DViewer();
        //             openClosetImage();
        //         })
        //         .catch((e) => {
        //             console.log(e);
        //             store.dispatch("alert_Forge", {
        //                 message: 'Please open 3d viewer or 360 Image first'
        //             })
        //         })
        //         .finally(() => {
        //             mainApp[`view${index}Type`] = '';
        //             mainApp[`isView${index}Visible`] = false;
        //             store.commit("setShowLoading", false);
        //         });

        //     return;
        // }

        openClosetImage();
    }
    getComparasionModeFOV(fov) {
        return fov * .6;
    }
    get3dVFovFormPanoramaHFov(panoramaHFOV) {
        // y = 0.0025x2 + 0.2835x + 3.1799
        // this equation is calculated with resolution 1600x900 and scale 100%
        // aspect ratio for 3d viewer in this calculated equation is 2.212766

        let aspectRatio = store.state.viewer.getState().viewport.aspectRatio;

        return ((0.0025 * panoramaHFOV * panoramaHFOV + 0.2835 * panoramaHFOV + 3.1799) * 2.212766) / aspectRatio;
    }
    mapPanoramaHFovTo3dVHov() {
        let fov = store.state.forgeService.panoramaViewer.getHfov();
        if (store.state.mainApp.localShowComparasionTool) {
            let vFov = this.get3dVFovFormPanoramaHFov(fov);
            store.state.viewer.navigation.setVerticalFov(vFov);
        } else {
            store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(fov));
        }
    }
    isHFovInBounds(hFov) {
        if (!this.panoramaViewer) return false;

        let bounds = this.panoramaViewer.getHfovBounds();
        let min = bounds[0];
        let max = bounds[1];

        return hFov >= min && hFov <= max;
    }
    formatValueToDisplayUnit(value) {
        if (!value) return "";

        return formatLength(value, store.state.userSettings.displaySettings.displayUnits)
    }
    isUSUnit(unit) {
        let usUnits = ['decimal-ft', 'ft-and-fractional-in', 'ft-and-decimal-in', 'decimal-in']
        if (usUnits.includes(store.state.userSettings.displaySettings.displayUnits)) {
            return true
        }
        return false
    }
    loadFilteredTags(assetId, searchText, reload, allProperties, types, sortProperty, ascending) {
        let date = (new Date()).getTime();

        this.lastLoadFilteredTags = date;

        return new Promise((resolve, reject) => {
            if (reload)
                store.commit("SET_FILTERED_TAGS", []);
            let currentCount = reload ? 0 : store.getters['GET_FILTERED_TAGS'].length;
            let text = searchText ? btoa(searchText) : '';

            let dataJson = {
                assetId: assetId,
                userId: store.state.userId,
                searchText64: text,
                index: currentCount,
                range: 50,
                types: types ?? "",
                sortProperty: sortProperty ?? "Name",
                ascending: ascending ?? true,
                allProperties: allProperties,
            };

            HttpService.post({
                url: `api/tags/getFilteredTags`,
                data: dataJson,
            }).then(response => {
                if (this.lastLoadFilteredTags != date) return;

                let tags = [];

                response.data.forEach(t => {
                    switch (t.discriminator) {
                        case "ForgeScaffold":
                            t = Object.assign(new ForgeScaffold(), t);
                            t.position = Object.assign(new THREE.Vector3(), t.position);
                            t.scale = Object.assign(new THREE.Vector3(), t.scale);
                            t.max = Object.assign(new THREE.Vector3(), t.max);
                            t.attachments = ForgeAttachment.parseAttachments(t.attachments);
                            t.parseComments();
                            break;
                        case "ForgeEquipment":
                            t = Object.assign(new ForgeEquipment(), t);
                            t.parseContent();
                            break;
                        case "ForgePipeline":
                            t = Object.assign(new ForgePipeline(), t);
                            t.parseContent();
                            break;
                        case "ForgeStructural":
                            t = Object.assign(new ForgeStructural(), t);
                            t.parseContent();
                            break;
                        case "ForgeInspection":
                            t = Object.assign(new ForgeInspection(), t);
                            t.parseContent();
                            break;
                        case "ForgeAnnotation":
                            t = Object.assign(new ForgeAnnotation(), t);
                            t.parseContent();
                            break;
                        default:
                            break;
                    }

                    tags.push(t);
                })

                if (reload)
                    store.commit("SET_FILTERED_TAGS", tags);
                else
                    store.commit("SET_FILTERED_TAGS", store.getters['GET_FILTERED_TAGS'].concat(tags));

                resolve(tags);
            }).catch(error => {
                reject(error);
            });
        });
    }
    loadPipelinesTags(assetId, searchText, reload, allProperties) {
        return new Promise((resolve, reject) => {
            if (reload) store.commit("SET_PIPELINES_TAGS", []);

            let currentCount = reload ? 0 : store.getters['GET_PIPELINES_TAGS'].length;
            let text = searchText ? btoa(searchText) : '';
            HttpService.get({
                url: `api/tags/pipeline/fetchPipelines?assetId=${assetId}&searchText64=${text}&index=${currentCount}&range=20&allProperties=${allProperties}`,
            }).then(response => {
                let result = response.data;
                let tags = result.tags.map(o => Object.assign(new ForgePipeline(), o));
                tags.forEach(o => o.parseContent());
                if (reload) {
                    store.commit("SET_PIPELINES_TAGS_COUNT", result.dbIds.length);
                    store.commit("SET_FILTERED_PIPELINES_TAGS_IDS", result.dbIds);
                    store.commit("SET_PIPELINES_TAGS", tags);
                } else {
                    store.commit("SET_PIPELINES_TAGS", store.getters['GET_PIPELINES_TAGS'].concat(tags));
                }
                resolve(tags);
            }).catch(error => {
                console.error(error)
                reject(error);
            });
        });
    }
    loadStructuralTags(assetId, searchText, reload, allProperties) {
        return new Promise((resolve, reject) => {
            if (reload) store.commit("SET_STRUCTURAL_TAGS", []);

            let currentCount = reload ? 0 : store.getters['GET_STRUCTURAL_TAGS'].length;
            let text = searchText ? btoa(searchText) : '';
            HttpService.get({
                url: `api/tags/structural/fetchStructural?assetId=${assetId}&searchText64=${text}&index=${currentCount}&range=20&allProperties=${allProperties}`,
            }).then(response => {
                let result = response.data;
                let tags = result.tags.map(o => Object.assign(new ForgeStructural(), o));
                tags.forEach(o => o.parseContent());
                if (reload) {
                    store.commit("SET_STRUCTURAL_TAGS_COUNT", result.dbIds.length);
                    store.commit("SET_FILTERED_STRUCTURAL_TAGS_IDS", result.dbIds);
                    store.commit("SET_STRUCTURAL_TAGS", tags);
                } else {
                    store.commit("SET_STRUCTURAL_TAGS", store.getters['GET_STRUCTURAL_TAGS'].concat(tags));
                }
                resolve(tags);
            }).catch(error => {
                console.error(error)
                reject(error);
            });
        });
    }
    loadAutomaticTags(assetId, searchText, reload, allProperties, callback) {
        if (reload)
            store.commit("SET_AUTOMATIC_TAGS", []);
        let currentCount = reload ? 0 : store.getters['GET_AUTOMATIC_TAGS'].length
        let text = searchText ? btoa(searchText) : '';
        HttpService.get({
            url: `api/equipments/fetchAutomaticEquipments?assetId=${assetId}&searchText64=${text}&index=${currentCount}&range=50&allProperties=${allProperties}`,
        }).then(response => {
            let res = response.data;
            store.commit("SET_AUTOMATIC_TAGS_COUNT", res.totalResult);
            store.commit("SET_FILTERED_AUTOMATIC_TAGS_IDS", res.allEquipmentsIds);
            let tags = res.equipments.map(o => Object.assign(new ForgeEquipment(), o));
            tags.forEach(o => o.parseContent());
            if (reload)
                store.commit("SET_AUTOMATIC_TAGS", tags);
            else
                store.commit("SET_AUTOMATIC_TAGS", store.getters['GET_AUTOMATIC_TAGS'].concat(tags));
            if (callback)
                callback(res);
        }).catch(error => {
            console.log(error)
        });
    }
    loadAMISInspectionBySearch(assetId, searchText, index, allProperties) {
        return new Promise((resolve, reject) => {
            let text = searchText ? btoa(searchText) : '';
            HttpService.get({
                url: `api/AMIS/fetchAMISInspections?assetId=${assetId}&searchText64=${text}&index=${index}&range=50&allProperties=${allProperties}`,
            }).then(response => {
                let fetchedInspections = response.data;
                fetchedInspections.inspections = fetchedInspections.inspections.map(o => Object.assign(new ForgeInspection(), o));
                fetchedInspections.inspections.forEach(o => o.parseContent());
                resolve(fetchedInspections);
            }).catch(error => {
                console.log(error)
                reject(error);
            });
        })
    }
    buildInspectionTree(objects) {
        const tree = { id: 'root', name: 'Inspection Tree', children: [] }

        const cl = { id: 'corrosion_loop', name: 'Corrosion Loop', children: [] };
        const fc = { id: 'fluid_classification', name: 'Fluid Classification', children: [] };

        objects.forEach(obj => {

            // Handling Corrosion Loop

            const clKey1 = obj.clNo1;

            if (clKey1) {
                const clId1 = `cl_${clKey1}`

                let clNode1 = cl.children.find(node => node.id === clId1);

                if (!clNode1) {
                    clNode1 = { id: clId1, name: clKey1, checked: false, children: [] };
                    cl.children.push(clNode1);
                }

                clNode1.children.push(obj);
            }

            const clKey2 = obj.clNo2;

            if (clKey2) {
                const clId2 = `cl_${clKey2}`

                let clNode2 = cl.children.find(node => node.id === clId2);

                if (!clNode2) {
                    clNode2 = { id: clId2, name: clKey2, checked: false, children: [] };
                    cl.children.push(clNode2);
                }

                clNode2.children.push(obj);
            }

            if (!clKey1 && !clKey2) {
                const clId = `cl__blank`
                let clNode = cl.children.find(node => node.id === clId);
                if (!clNode) {
                    clNode = { id: clId, name: "_blank", checked: false, children: [] };
                    cl.children.push(clNode);
                }
                clNode.children.push(obj);
            }

            // Handling Fluid Classification

            const fcKey1 = obj.fluidClassification1;

            if (fcKey1) {
                const fcId1 = `fc_${fcKey1}`

                let fcNode1 = fc.children.find(node => node.id === fcId1);

                if (!fcNode1) {
                    fcNode1 = { id: fcId1, name: fcKey1, checked: false, children: [] };
                    fc.children.push(fcNode1);
                }

                fcNode1.children.push(obj);
            }

            const fcKey2 = obj.fluidClassification2;

            if (fcKey2) {
                const fcId2 = `fc_${fcKey2}`

                let fcNode2 = fc.children.find(node => node.id === fcId2);

                if (!fcNode2) {
                    fcNode2 = { id: fcId2, name: fcKey2, checked: false, children: [] };
                    fc.children.push(fcNode2);
                }

                fcNode2.children.push(obj);
            }

            if (!fcKey1 && !fcKey2) {
                const fcId = `fc__blank`
                let fcNode = fc.children.find(node => node.id === fcId);
                if (!fcNode) {
                    fcNode = { id: fcId, name: "_blank", checked: false, children: [] };
                    fc.children.push(fcNode);
                }
                fcNode.children.push(obj);
            }
        });

        if (cl.children.length) tree.children.push(cl);
        if (fc.children.length) tree.children.push(fc);

        return tree;
    }
    loadAMISTagsAdvanced(searchText, reload) {
        if (!store.state.forgeSettings?.isAMIS) return;

        store.state.TAGS.isLoadingAMISTags = true;
        let requestDate = Date.now();
        store.commit('SET_LAST_AMIS_ADVANCED_FETCH_DATE', requestDate);

        if (reload) store.commit("SET_AMIS_TAGS", []);

        let currentCount = reload ? 0 : store.getters['GET_AMIS_TAGS'].length

        let text = searchText ? btoa(searchText) : ''

        let units = store.getters['GET_AMIS_UNITS']

        units = units.filter(o => o.isChecked).map(o => o.name);

        if (units.length == 0) {
            store.commit("SET_AMIS_TAGS_SEARCH_COUNT", 0);
            store.commit("SET_AMIS_TAGS_TOTAL_COUNT", 0);
            store.commit("SET_AMIS_TAGS", []);
            store.state.TAGS.isLoadingAMISTags = false;
            store.state.forgeService.update3dIconsInAllViews();
            return;
        }

        let sorting = store.state.TAGS.sortingData.find(t => t.isSelected);

        let data = {
            'assetId': store.state.assetId,
            'orderBy': {
                property: sorting?.id ?? 'Name',
                ascending: sorting?.isAsc ?? true,
            },
            'searchText64': text,
            'searchIndex': currentCount,
            'searchRange': 50,
            'SelectedUnits': units,
            'selectedFilter': store.state.TAGS.InspectionFiltersOptions.indexOf(store.state.TAGS.InspectionSelectedFilter) + 1,
            'reloading': reload
        }
        let selectedColorOptions = store.state.TAGS.selectedColorOptions;
        if (selectedColorOptions.length) {
            data['filters'] = selectedColorOptions.map(o => {
                return {
                    'filterValue1': o.judgCrr1?.toString()?.includes('∞') ? 10e5 : o.judgCrr1,
                    'compareSign1': o.judgMkr1?.trim(),
                    'filterValue2': o.judgCrr2?.toString()?.includes('-∞') ? -10e5 : o.judgCrr2,
                    'compareSign2': o.judgMkr2?.trim(),
                }
            })
        }

        postDataAsync('api/AMIS/fetchInspectionsAdvanced', data, res => {
            if (store.getters['GET_LAST_AMIS_ADVANCED_FETCH_DATE'] !== requestDate) return;

            let { totalSearchResult, allTagsCount, inspections, allFilteredInspections } = res;

            store.commit("SET_AMIS_TAGS_SEARCH_COUNT", totalSearchResult);
            store.commit("SET_AMIS_TAGS_TOTAL_COUNT", allTagsCount);

            let tags = inspections.map(o => Object.assign(new ForgeInspection(), o));

            tags.forEach(o => o.parseContent());

            if (reload) {
                store.commit("SET_AMIS_TAGS", tags);

                allFilteredInspections = allFilteredInspections.map(o => Object.assign(new ForgeInspection(), o));

                allFilteredInspections.forEach(o => {
                    o.isFetched = true;
                    o.parseContent()
                });

                store.commit("SET_ALL_AMIS_FILTERED_INSPECTIONS", allFilteredInspections);

                store.commit('SET_INSPECTION_TAG_TREE', this.buildInspectionTree(allFilteredInspections))
            }
            else {
                store.commit("SET_AMIS_TAGS", store.getters['GET_AMIS_TAGS'].concat(tags));
            }
            store.state.TAGS.isLoadingAMISTags = false;
            store.dispatch('LOAD_AMIS_COLORS', () => {
                // TODO: Create inspection color map { inspectionId: color } and use it in all required places.
                store.state.forgeService.updateAMISTagsColors(store.state.TAGS.amisTags);
                store.state.forgeService.updateAMISTagsColors(store.getters.GET_ALL_AMIS_FILTERED_INSPECTIONS);
                store.state.forgeService.updateAMISTagsColors(store.getters.GET_ALL_AMIS_TAGS_IDS);
                store.state.forgeService.update3dIconsInAllViews();
            })
        }, err => {
            store.state.TAGS.isLoadingAMISTags = false;
            store.dispatch({ type: "alert_Forge", message: 'Faild to fetch A-MIS inspections.' })
        });
    }
    updateAMISTagsColors(tags, defaultColor = '#6d2251') {
        let InspectionSelectedFilter = store.state.TAGS.InspectionSelectedFilter;
        let selectedColorsOptions = store.state.TAGS.InspectionAvailableColorOptions;

        this.advancedUpdateAMISTagsColors(tags, InspectionSelectedFilter, selectedColorsOptions, defaultColor)
    }
    advancedUpdateAMISTagsColors(tags, InspectionSelectedFilter, selectedColorsOptions, defaultColor = '#6d2251') {
        let targetProperty = '';

        if (InspectionSelectedFilter == "Remaining Thickness") targetProperty = 'rt';
        else if (InspectionSelectedFilter == "Remaining Life") targetProperty = 'rl';
        else if (InspectionSelectedFilter == "Corrosion Rate") targetProperty = 'cr';
        else if (InspectionSelectedFilter == "Inspection Plan") targetProperty = 'ispDateDays';
        else if (InspectionSelectedFilter == "Last Inspection (Thickness)") targetProperty = 'ispDateDays';
        else if (InspectionSelectedFilter == "Last Inspection (Visual)") targetProperty = 'offerLastInspDateDays';
        else if (InspectionSelectedFilter == "Last Inspection (Both)") targetProperty = 'nearestLastDateDays';
        else if (InspectionSelectedFilter == "Next Inspection (Thickness)") targetProperty = 'nIspDateDays';
        else if (InspectionSelectedFilter == "Next Inspection (Visual)") targetProperty = 'offerNextInspDateDays';
        else if (InspectionSelectedFilter == "Next Inspection (Both)") targetProperty = 'closestNextDateDays';

        tags.forEach(tag => {
            tag.pinColor = this.getAMISTagColor(tag, selectedColorsOptions, targetProperty, defaultColor);
        })
    }
    getAMISTagColor(tag, selectedColorsOptions, targetProperty, defaultColor = '#6d2251') {
        let color = defaultColor;

        for (let i = 0; i < selectedColorsOptions.length; i++) {
            const o = selectedColorsOptions[i];

            let j1 = o.judgCrr1?.toString().includes('∞') ? Infinity : o.judgCrr1;
            let j2 = o.judgCrr2?.toString().includes('-∞') ? -Infinity : o.judgCrr2;

            if (o.judgMkr1 == "<" && o.judgMkr2 == '>=') {
                if (tag[targetProperty] !== null && (tag[targetProperty] < j1) && (tag[targetProperty] >= j2)) {
                    color = o.judgCor;
                    break;
                }
            } else if (o.judgMkr1 == "<" && o.judgMkr2 == '>') {
                if (tag[targetProperty] !== null && (tag[targetProperty] < j1) && (tag[targetProperty] > j2)) {
                    color = o.judgCor;
                    break;
                }
            } else if (o.judgMkr1 == "<=" && o.judgMkr2 == '>') {
                if (tag[targetProperty] !== null && (tag[targetProperty] <= j1) && (tag[targetProperty] > j2)) {
                    color = o.judgCor;
                    break;
                }
            } else if (o.judgMkr1 == "<=" && o.judgMkr2 == '>=') {
                if (tag[targetProperty] !== null && (tag[targetProperty] <= j1) && (tag[targetProperty] >= j2)) {
                    color = o.judgCor;
                    break;
                }
            } else if (o.judgMkr1 == null && o.judgMkr2 == null && tag[targetProperty] === null) {
                color = o.judgCor;
                break;
            }
        }

        return color;
    }
    getCategoryColor(categoryId) {
        let category = store.state.categories.find(c => c.id == categoryId);

        if (category) {
            return {
                r: parseInt(category.color.substr(1, 2), 16) / 255,
                g: parseInt(category.color.substr(3, 2), 16) / 255,
                b: parseInt(category.color.substr(5, 2), 16) / 255
            }
        }

        return { r: 3.0, g: 3.0, b: 3.0 };
    }
}

export function getAuthHeaders() {
    let isOrigin = store.getters['getParentSiteName']?.toLowerCase() == 'origin';
    if (isOrigin) {
        return {};
    }
    const authToken = getURLParameterVal('token');
    return {
        "Authorization": `Bearer ${authToken}`,
    };
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
export function downloadShareFileById(id, callback) {
    //NOTE: you have to add the site to the ShareFile site first to avoid the CORS issue.
    //Go to ShareFile > Secuirity > Login & Security Policy > Trusted domains
    //then add all the clients

    //ShareFile documentation here
    //https://api.sharefile.com/docs/resource?name=Items
    $.ajax({
        "url": "https://modsmanagement.sf-api.com/sf/v3/Items(" + id + ")/Download?redirect=false",
        "method": "GET",
        "headers": {
            "Authorization": "Bearer " + store.state.shareFileToken,
        },
    }).done(function (response) {
        window.open(response.DownloadUrl, '_blank')
        if (callback)
            callback()
    });
}
export function downloadBlobUrl(uri, name) {
    convertBlobUrlToBase64(uri, store.state.viewer.container.clientWidth, store.state.viewer.container.clientWidth, base64 => {

        let link = document.createElement("a");
        base64 = base64.replace("image/png", "image/octet-stream");
        link.setAttribute("href", base64);

        if (!name.endsWith('.png'))
            name += '.png';
        link.setAttribute('download', name);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}
export function downloadURI(uri, name) {
    const link = document.createElement("a");
    link.href = uri;
    if (name)
        link.setAttribute('download', name);
    link.setAttribute('target', '_blank');
    document.body.append(link)
    link.click()
    document.body.removeChild(link);

}

export function readFileContent(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (event) => resolve((event.target).result);
        reader.onerror = error => reject(error);
        reader.readAsText(file)
    });
}
//https://stackoverflow.com/questions/3665115/how-to-create-a-file-in-memory-for-user-to-download-but-not-through-server
export function downloadTextInFile(filename, text) {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

//https://stackoverflow.com/questions/13405129/javascript-create-and-save-file
// function download(data, filename) {
//     let file = new Blob([data], { type: "text/plain;charset=utf-8" });
//     if (window.navigator.msSaveOrOpenBlob) // IE10+
//         window.navigator.msSaveOrOpenBlob(file, filename);
//     else { // Others
//         let a = document.createElement("a"),
//             url = URL.createObjectURL(file);
//         a.href = url;
//         a.download = filename;
//         document.body.appendChild(a);
//         a.click();
//         setTimeout(function () {
//             document.body.removeChild(a);
//             window.URL.revokeObjectURL(url);
//         }, 0);
//     }
// }
export function take360Screenshot(viewer, callback) {
    let screenshot = viewer.getRenderer().render(viewer.getPitch() / 180 * Math.PI, viewer.getYaw() / 180 * Math.PI, viewer.getHfov() / 180 * Math.PI, { 'returnImage': true });

    let i = new Image();

    i.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = i.width / 2;
        canvas.height = i.height / 2;
        let context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.scale(0.5, 0.5);
        context.drawImage(this, 0, 0);
        let base64 = canvas.toDataURL('image/png');
        canvas.remove();
        callback(base64);
    };

    i.src = screenshot;
}
export function takeScreenshot(viewer, callback) {
    viewer.getScreenShot(viewer.container.clientWidth, viewer.container.clientHeight, function (blobURL) {
        convertBlobUrlToBase64(blobURL, viewer.container.clientWidth, viewer.container.clientHeight, callback);
    });
}
export function convertBlobUrlToBase64(blobURL, width, height, callback) {
    let image = new Image();
    image.crossOrigin = 'Anonymous'
    image.onload = function () {
        let canvas = document.getElementById('screenshot');
        if (!canvas) {
            canvas = document.createElement('canvas');
            canvas.id = "screenshot";
            canvas.style.position = "absolute";
            canvas.style.display = "block";
            document.body.appendChild(canvas);
        }
        canvas.width = width;
        canvas.height = height;
        let canvasContext = canvas.getContext('2d');
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
        canvasContext.drawImage(image, 0, 0, canvas.width, canvas.height);

        let base64 = canvas.toDataURL('image/png');
        document.getElementById('screenshot').remove();
        callback(base64);
    }
    image.src = blobURL;
}
export function debounce(func, timeout = 100) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
//https://stackoverflow.com/questions/808826/draw-arrow-on-canvas-tag
export function canvas_arrow(context, fromx, fromy, tox, toy) {
    let headlen = 10; // length of head in pixels
    let dx = tox - fromx;
    let dy = toy - fromy;
    let angle = Math.atan2(dy, dx);
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
    context.moveTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
}
export function canvas_dimension_line(context, fromx, fromy, tox, toy) {
    let headlen = 10; // length of head in pixels
    let dx = tox - fromx;
    let dy = toy - fromy;
    let angle = Math.atan2(dy, dx);
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
    context.moveTo(tox, toy);
    context.lineTo(tox + headlen * Math.cos(angle - Math.PI / 6), toy + headlen * Math.sin(angle - Math.PI / 6));
}
//https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-using-html-canvas
// type: all, top, left, right, bottom
export function roundRect(ctx, x, y, width, height, radius, type, fill, stroke) {
    if (typeof stroke === 'undefined') {
        stroke = true;
    }
    if (typeof radius === 'undefined') {
        radius = 5;
    }
    if (typeof radius === 'number') {
        if (type == "top") {
            radius = { tl: radius, tr: radius, br: 0, bl: 0 };
        } else if (type == 'bottom') {
            radius = { tl: 0, tr: 0, br: radius, bl: radius };
        } else if (type == 'left') {
            radius = { tl: radius, tr: 0, br: 0, bl: radius };
        } else if (type == 'right') {
            radius = { tl: 0, tr: radius, br: radius, bl: 0 };
        } else {
            radius = { tl: radius, tr: radius, br: radius, bl: radius };
        }
    } else {
        let defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
        for (let side in defaultRadius) {
            radius[side] = radius[side] || defaultRadius[side];
        }
    }
    ctx.beginPath();
    ctx.moveTo(x + radius.tl, y);
    ctx.lineTo(x + width - radius.tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    ctx.lineTo(x + width, y + height - radius.br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    ctx.lineTo(x + radius.bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    ctx.lineTo(x, y + radius.tl);
    ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    ctx.closePath();
    if (fill) {
        ctx.fill();
    }
    if (stroke) {
        ctx.stroke();
    }
}
export function bytesToSize(bytes) {
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}
//making same as what is done in this webpage
//https://thaivaluer.com/proj4js/xydatum.html
export function initProj4() {
    Proj4js.defs["EPSG:24047"] = "+title=Indian 1975 / UTM zone 47N+proj=utm +zone=47 +a=6377276.345 +b=6356075.41314024 +towgs84=204.5,837.9,294.8,0,0,0,0 +units=m +no_defs"
    Proj4js.defs["WGS84"] = "+title=long/lat:WGS84 +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"
}
export function convertLatLongToXYZCoordinates_Indian(latLong) {
    if (!store.state.forgeSettings || !store.state.forgeSettings.gpsSettings)
        return null;
    let ORIGIN_N = store.state.forgeSettings.gpsSettings.originN;
    let ORIGIN_E = store.state.forgeSettings.gpsSettings.originE;
    let a = store.state.forgeSettings.gpsSettings.CONST_A;
    let b = store.state.forgeSettings.gpsSettings.CONST_B;
    let angle = store.state.forgeSettings.gpsSettings.angle;
    const theta = THREE.Math.degToRad(angle);

    let projSource = new Proj4js.Proj("WGS84")
    let projDest = new Proj4js.Proj("EPSG:24047")

    let pointSource = new Proj4js.Point(latLong.long.toString() + ',' + latLong.lat.toString());
    let utmPoint = Proj4js.transform(projSource, projDest, pointSource);

    let E = utmPoint.x - ORIGIN_E;
    let N = utmPoint.y - ORIGIN_N;
    let y = (E * Math.sin(theta) - a * Math.cos(theta) + N * Math.cos(theta) - b * Math.sin(theta)) / (Math.pow(Math.cos(theta), 2) + Math.pow(Math.sin(theta), 2));
    let x = (y * Math.cos(theta) + a - N) / Math.sin(theta);
    let z = store.state.viewer ? store.state.viewer.model.getGlobalOffset().z - 8 : 10;
    return new THREE.Vector3(x, y, z);
}
export function getRotatedDirectionByNorthAngle() {
    if (!store.state.forgeSettings || !store.state.forgeSettings.gpsSettings || !store.state.forgeSettings.gpsSettings.angle)
        return null;
    let angle = store.state.forgeSettings.gpsSettings.angle;
    let axis = new THREE.Vector3(0, 0, 1);
    let vec2D = new THREE.Vector3(0, 1, 0);
    vec2D.applyAxisAngle(axis, THREE.Math.degToRad(angle));
    return vec2D;
}

export function formatLength(length, type) {
    let fileUnit = 'm'

    let lengthFeet = getLengthInFeet(length, fileUnit);

    if (type == 'decimal-ft') {
        return lengthFeet.toFixed(2) + '\'';
    }
    else if (type == 'ft-and-fractional-in') {
        let feet = parseInt(lengthFeet);
        let inches = (lengthFeet - feet) * 12;
        let pureInch = parseInt(inches);
        let fractions = inches - pureInch;
        if (fractions > .75)
            return `${feet}' ${pureInch}-3/4"`
        else if (fractions > .5)
            return `${feet}' ${pureInch}-1/2"`
        else
            return `${feet}' ${pureInch}-1/4"`
    }
    else if (type == 'ft-and-decimal-in') {
        let feet = parseInt(lengthFeet);
        let inches = (lengthFeet - feet).toFixed(2);
        if (inches == 0)
            return `${feet}'`;
        return `${feet}' ${inches}"`;
    }
    else if (type == 'decimal-in') {
        return (lengthFeet * 12).toFixed(2) + '"';
    }
    else if (type == 'm') {
        return (lengthFeet * 0.3048).toFixed(2) + 'm';
    }
    else if (type == 'cm') {
        return (lengthFeet * 30.48).toFixed(2) + 'cm';
    }
    else if (type == 'mm') {
        return (lengthFeet * 304.8).toFixed(2) + 'mm';
    }
}

export function getLengthInFeet(length, type) {
    if (type == 'ft') return length;
    else if (type == 'in') return (length / 12);
    else if (type == 'm') return (length / 0.3048);
    else if (type == 'cm') return (length / 30.48);
    else if (type == 'mm') return (length / 304.8);
}

export function saveAttachmentToDatabase(attachment) {
    let dataJson = attachment;

    HttpService.put({
        url: `api/forge/attachments/editAttachment`,
        data: dataJson,
    }).then(response => {
        store.dispatch('RequestPIdsLinkedTags');

        let res = response.data;

        if (!res.pagesMarkups) return;

        for (let i = 0; i < res.pagesMarkups.length; i++) {
            const dbPage = res.pagesMarkups[i];
            let page = attachment.pagesMarkups.find(o => o.pageId / 1 == dbPage.pageId / 1);

            if (page == null) continue;

            page.id = dbPage.id;

            if (!page.links?.length) continue;

            for (let i = 0; i < dbPage.links.length; i++) {
                if (page.links[i].id) continue;
                page.links[i].id = dbPage.links[i].id;
            }
        }
    }).catch(error => {
        console.log(error)
    });
}

export function loadScript(url, onCallBack, onError) {
    const script = document.createElement('script');
    let scriptName = url.slice(url.lastIndexOf('/') + 1, url.length)
    if (isScriptLoaded(scriptName)) {
        if (onCallBack) onCallBack();
    } else {
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', url);
        script.onload = onCallBack;
        script.onerror = onError;
        document.body.appendChild(script);
    }
}

export function unloadScript(scriptName) {
    let scripts = document.scripts;
    let script = '';
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.toLowerCase().includes(scriptName.toLowerCase())) {
            script = scripts[i];
            break;
        }
    }
    script.parentElement.removeChild(script);
}

export function isScriptLoaded(scriptName) {
    let scripts = document.scripts;
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.toLowerCase().includes(scriptName.toLowerCase())) {
            return true;
        }
    }
    return false;
}
export function renderPDFThumbnailToCanvas(pdfUrl, canvas) {
    //https://www.codegrepper.com/code-examples/javascript/how+to+generate+thumbnail+fast+in+pdfjs
    //https://stackoverflow.com/questions/66974404/how-to-import-pdf-js-using-cdn
    pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.7.570/build/pdf.worker.min.js";

    pdfjsLib.getDocument(pdfUrl).promise.then(function (doc) {
        doc.getPage(1).then(page => {
            var scale = canvas.width / page._pageInfo.view[2]
            var vp = page.getViewport({ scale: scale });
            page.render({ canvasContext: canvas.getContext("2d"), viewport: vp, intent: 'print' })
        })
    }).catch(console.error);
}

export function delay(milliSeconds) {
    return new Promise(resolve => setTimeout(resolve, milliSeconds));
}
export function getShareFileAccessToken(callback) {
    HttpService.get({
        url: `api/sharefile/getAccessToken`,
    }).then(response => {
        callback(response.data);
    }).catch(error => {
        console.log(error)
    });
}
export function getShareFileTopFolders(token, callback) {
    HttpService.get({
        url: `api/sharefile/getTopFolders/?token=${token}`,
    }).then(response => {
        callback(response.data);
    }).catch(error => {
        console.log(error)
    });
}
export function getShareFileFolderChildren(id, token, callback) {
    HttpService.get({
        url: `api/sharefile/getFolderChildren/?id=${id}&token=${token}`,
    }).then(response => {
        let data = response.data;

        if (!data) {
            callback([]);
            return;
        }
        let items = JSON.parse(data).Children;
        let result = items.map(o => new ShareFileItem(o.Name, o.Id, o['odata.type'].endsWith('Folder'), o.FileSizeBytes, o.url));

        callback(result);
    }).catch(error => {
        console.log(error)
    });
}

export function loadImage(url) {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = function () {
            resolve(this);
        }
        img.src = url;
    });
}

export const PopupStatus = Object.freeze({
    ACTIVE: 'active',
    FULLSCREEN: 'fullscreen',
    MINIMIZED: 'minimized',
    HIDDEN: 'hidden',
    UNDEFINED: 'undefined',
});

export const ForgeVisiblityMode = Object.freeze({
    SHOW: 'show',
    SELECT: 'select',
    HIDE: 'hide',
    ISOLATE: 'isolate',
});

export async function exportAttachmentWithMarkupsPdf(attachment, fileName) {
    try {
        if (!attachment) {
            store.dispatch({ type: "alert_Forge", message: "No attachment provided." });
            return;
        }

        var pdfUrl = attachment.blobUrl || attachment.pdfUrl || attachment.url || attachment.sourceUrl;

        if (!pdfUrl) {
            store.dispatch({ type: "alert_Forge", message: "Attachment PDF URL not found." });
            return;
        }

        var doc = await window.pdfjsLib.getDocument(pdfUrl).promise;

        var out = new jsPDF({ unit: "px", format: "a4", compress: true });
        out.deletePage(1);

        var loadImageAnon = (url) =>
            new Promise((resolve, reject) => {
                var img = new Image();
                img.crossOrigin = "anonymous";
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = url;
            });

        var pageMarkupById = {};
        (attachment.pagesMarkups || []).forEach((p) => {
            if (p?.pageId != null) pageMarkupById[p.pageId] = p;
        });

        var getExportFileName = () => {
            try {
                if (attachment?.url) {
                    var last = decodeURIComponent(attachment.url.split("/").pop().split("?")[0]);
                    if (/\.[A-Za-z0-9]{2,8}$/.test(last)) {
                        return last.replace(/(\.[A-Za-z0-9]{2,8})$/, "_MarkUp$1");
                    }
                }

                var base = fileName || attachment?.name || store?.state?.testPackageNumber || "MarkupsExport";
                return base.endsWith(".pdf") ? base : base + ".pdf";
            } catch {
                return "MarkupsExport.pdf";
            }
        };

        for (var pageNum = 1; pageNum <= doc.numPages; pageNum++) {
            var page = await doc.getPage(pageNum);
            var pm = pageMarkupById[pageNum];

            var viewport = page.getViewport({ scale: 2, rotation: Math.ceil(pm.rotation * (180 / Math.PI)) }); //adjust for better quality
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            await page.render({ canvasContext: ctx, viewport }).promise;

            var overlayUrl = pm?.imageAbsoluteUrl || pm?.imageUrl;
            if (overlayUrl) {
                try {
                    var markupImg = await loadImageAnon(overlayUrl);
                    ctx.drawImage(markupImg, 0, 0, canvas.width, canvas.height);
                } catch (e) {
                    console.warn(`Failed loading markup image for page ${pageNum}`, e);
                }
            }

            var w = canvas.width;
            var h = canvas.height;
            var orientation = w > h ? "l" : "p";
            out.addPage([w, h], orientation);
            out.setPage(out.getNumberOfPages());
            var dataUrl = canvas.toDataURL("image/jpeg", 1.0);
            out.addImage(dataUrl, "JPEG", 0, 0, canvas.width, canvas.height);
        }

        var name = getExportFileName();
        out.save(name);
    } catch (err) {
        console.error(err);
        store.dispatch({
            type: "alert_Forge",
            message: "Failed to export PDF with markups.",
        });
    }
}

//used to export current PDF viewer scene to 
export async function exportPDF(viewer, fileName, isBounded = false) {

    //Create Image element to bind viewer screenshot into
    let screenshotImage = new Image();

    //Create canvas element to render screenshot image as well as markups
    let canvas = document.createElement('canvas');
    canvas.id = "snapshot";
    canvas.style.position = "absolute";
    viewer.container.parentElement.appendChild(canvas);

    //In case want to crop the screenshot to model boundary only
    let modelBoundingBox = viewer.model.getBoundingBox();
    let modelClientMax = viewer.worldToClient(modelBoundingBox.max);
    let modelClientMin = viewer.worldToClient(modelBoundingBox.min);
    let modelHeight = Math.abs(modelClientMax.y - modelClientMin.y);
    let modelWidth = Math.abs(modelClientMax.x - modelClientMin.x);
    let modelLeft = modelClientMin.x;
    let modelTop = modelClientMax.y;
    canvas.width = isBounded ? modelWidth : viewer.canvas.width;
    canvas.height = isBounded ? modelHeight : viewer.canvas.height;
    canvas.style.left = isBounded ? modelLeft + 'px' : 0;
    canvas.style.top = isBounded ? modelTop + 'px' : 0;

    //Get Markups Extension
    let markupCore = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];

    //Image.onload should be dispatched when viewer.getScreenShot assings "screenshot" element src
    screenshotImage.onload = async function () {
        let ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        //render image [from viewer.screenshot] to canvas
        //https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage
        if (isBounded) {
            //drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
            ctx.drawImage(screenshotImage, modelLeft, modelTop, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
        } else {
            //drawImage(image, dx, dy, dWidth, dHeight)
            ctx.drawImage(screenshotImage, 0, 0, canvas.width, canvas.height);
        }

        //render all markups to canvas
        // if Markups.Core not loaded, export PDF with image only
        if (markupCore) {
            // markupCore?.renderToCanvas(,,true) to render all layers
            markupCore.renderToCanvas(ctx, async () => {
                let imgData = canvas.toDataURL();
                await saveImageToPDF(imgData, canvas.width, canvas.height, fileName);
                viewer.container.parentElement.removeChild(canvas);
            }, true);
        } else {
            let imgData = canvas.toDataURL();
            await saveImageToPDF(imgData, canvas.width, canvas.height, fileName);
            viewer.container.parentElement.removeChild(canvas);
        }

    }
    //Get Viewer screenshot and bind it to image []
    viewer.getScreenShot(viewer.canvas.width, viewer.canvas.height, function (blobURL) {
        screenshotImage.src = blobURL;
    });
}

export async function saveImageToPDF(imgData, width, height, fileName) {
    //create PDF document using jsPDF lib
    let doc = new jsPDF({ format: [height, width], orientation: "landscape" });

    //Add Image to document page
    await doc.addImage(imgData, 'JPEG', 0, 0, width, height);

    await doc.save(fileName ?? window.location.origin);
}

export function exportMarkupImageWithModel(viewer, saveAsPng, saveAsPdf, fileName, callback) {
    let canvas = document.getElementById('snapshot');
    if (!canvas) {
        canvas = document.createElement('canvas'); 
        canvas.id = 'snapshot';
    }
    canvas.width = viewer.container.clientWidth * 4;
    canvas.height = viewer.container.clientHeight * 4;
    viewer.container.appendChild(canvas);

    let screenshotImage = new Image(canvas.width, canvas.height);
    let markupImage = new Image(canvas.width, canvas.height);
    let imageBase64 = '';
    screenshotImage.onload = function () {
        let markupExtension = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore']
        // prepare to render the markups
        let ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(screenshotImage, 0, 0, canvas.width, canvas.height);

        let data = markupExtension.editModeSvgLayerNode ? markupExtension.generateData() : markupExtension.svg.innerHTML;

        markupImage.onload = async function () {
            ctx.drawImage(markupImage, 0, 0, canvas.width, canvas.height);
            function getImageBase64(saveAsPng, saveAsPdf) {
                imageBase64 = canvas.toDataURL();
                if (saveAsPng) {
                    const a = document.createElement('a');
                    a.style = 'display: none';
                    document.body.appendChild(a);
                    a.href = imageBase64;
                    a.download = 'markup.png';
                    a.click();
                    document.body.removeChild(a);
                }
                if (saveAsPdf) {
                    let imgData = canvas.toDataURL();
                    saveImageToPDF(imgData, canvas.width, canvas.height, fileName);
                }
                if (callback) {
                    callback();
                }
            }
            getImageBase64(saveAsPng, saveAsPdf);
        }
        markupImage.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(data)));

        return imageBase64;
    };

    // Get the full image
    viewer.getScreenShot(viewer.container.clientWidth * 4, viewer.container.clientHeight * 4, function (blobURL) {
        screenshotImage.src = blobURL;
    })
}

export function exportMarkupImage(viewer, callback) {
    let markupExtension = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];
    let canvas = document.getElementById('markupsSnapshot');
    if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.id = 'markupsSnapshot';
    }
    let modelSize = getModelClientDimensions(viewer, viewer.model);
    let modelWidth = Math.abs(modelSize.x);
    let modelLength = Math.abs(modelSize.y);
    canvas.width = modelWidth * 2;
    canvas.height = modelLength * 2;
    viewer.container.appendChild(canvas);
    let ctx = canvas.getContext('2d');
    let svgHeight = markupExtension.svg.clientHeight;
    let svgWidth = markupExtension.svg.clientWidth;
    let leftMargin = (svgWidth - modelWidth) / 2;
    let topMargin = (svgHeight - modelLength) / 2;
    let img = new Image(svgWidth, svgHeight);
    let data = markupExtension.editModeSvgLayerNode ? markupExtension.generateData() : markupExtension.svg.innerHTML;

    if (!data) {
        if (callback) callback(null);
        return;
    }

    img.onload = async function () {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, leftMargin, topMargin, svgWidth - 2 * leftMargin, svgHeight - 2 * topMargin, 0, 0, canvas.width, canvas.height);
        let imageBase64 = canvas.toDataURL();
        if (callback) callback(imageBase64);
    }
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(data)));
}

export function exportMarkupImage2(viewer, callback) {
    let markupExtension = viewer.loadedExtensions['Autodesk.Viewing.MarkupsCore']
    let canvas = document.getElementById('markupsSnapshot');
    if (!canvas) {
        let canvas = document.createElement('canvas');
        canvas.id = 'markupsSnapshot';
    }
    canvas.width = viewer.container.clientWidth * 2;
    canvas.height = viewer.container.clientHeight * 2;
    viewer.container.appendChild(canvas);
    let ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(new Image(canvas.width, canvas.height), 0, 0, canvas.width, canvas.height);


    markupExtension.renderToCanvas(ctx, function () {
        let ImageBase64 = canvas.toDataURL();

        if (callback) {
            callback(ImageBase64);
        }
    }, true);
}

export function urlToBase64(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function () {
        let reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

export function imageToBase64(img) {
    img.crossOrigin = "anonymous";
    let canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let dataURL = canvas.toDataURL("image/png");
    return dataURL;
}

export async function exportAttachmentsPDF(attachmentsIds, fileName) {
    let attachments = await getAttachments(attachmentsIds);
    let imagesUrls = attachments.flatMap(o => o.pagesMarkups).map(o => o.imageUrl);

    //filter that No url is empty or null
    imagesUrls = imagesUrls.filter(x => { return x != "" && x != null });

    //create PDF document using jsPDF lib
    let doc = new jsPDF();
    //delete default first page
    doc.deletePage(1);

    for (let i = 0; i < imagesUrls.length; i++) {
        const url = imagesUrls[i];
        let currentPageNumber = i + 1;

        $(`<img crossorigin="anonymous" src=${url} id=${currentPageNumber}>`).on('load', function () {
            let img = $(this)[0]
            let pageNumber = img.id

            //Add Page to document
            doc.addPage();
            doc.setPage(pageNumber);

            let height = img.height;
            let width = img.width;

            doc.setPageHeight(pageNumber, height)
            doc.setPageWidth(pageNumber, width)

            let imageBase64 = imageToBase64(img);

            //Add Image to document page
            doc.addImage(imageBase64, 'JPEG', 0, 0, width, height);

            if (doc.getNumberOfPages() == imagesUrls.length) {
                //All pages are added
                //Export Document
                doc.save(fileName ?? window.location.origin);
            }
        })
    }
}

export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

export function updateMarkupsStyle(style) {
    style = JSON.parse(style)
    let extension = store.state.markupsComponent.autodeskMarkupsExtension;
    if (extension.editMode) {
        extension.setStyle(style);
    } else {
        extension.enterEditMode()
        extension.setStyle(style);
        extension.leaveEditMode();
    }
}

export async function addMarkupsForPrint(viewer, editor) {
    const avemc = Autodesk.Viewing.Extensions.Markups.Core;

    let templateStyle = {
        "font-size": 0.4,
        "stroke-color": "#0000FF",
        "stroke-opacity": 1,
        "fill-color": "#ffffff",
        "fill-opacity": 0,
        "font-family": "Arial",
        "font-style": "normal",
        "font-weight": "bold"
    }
    let markups = [];

    //Create Test Package Number Markups
    let id = store.state.forgeService.newGuid();
    let modelBBox = viewer.model.getBoundingBox();
    templateStyle["font-size"] = 0.02 * modelBBox.max.y;
    let size = { "x": modelBBox.max.x / 3, "y": 0.03 * modelBBox.max.y };
    let position = { "x": size.x / 2, "y": modelBBox.max.y - (size.y / 2) };
    let testPackageNumber = store.getters['getTestPackageNumber'];
    let createMarkup = new avemc.CreateText(editor, id, position, size, testPackageNumber, templateStyle);
    createMarkup.selectOnExecution = false;
    createMarkup.execute();
    editor.enterEditMode('Layer_1');
    let markup = editor.getMarkup(id);
    markup.isTemp = true;
    markups.push(markup);

    //Create Link Number Markup
    id = store.state.forgeService.newGuid();
    position = { "x": size.x / 2, "y": (size.y / 2) };
    let moduleUrl = store.state.parentModuleUrl;
    let contextId = store.state.MARKUPS.activeAttachment.referenceContextId;
    let targetId = store.state.MARKUPS.activeAttachment.referenceDocumentId;
    let url = `${moduleUrl}/odata/forgeLink?$filter=ContextID eq ${contextId} and TargetID eq ${targetId}`;
    let linksResponse = await getJSON(url);
    if (linksResponse && linksResponse.value && linksResponse.value.length > 0) {
        let link = linksResponse.value[0];
        let linkName = link.LinkName;
        createMarkup = new avemc.CreateText(editor, id, position, size, linkName, templateStyle);
        createMarkup.selectOnExecution = false;
        createMarkup.execute();
        editor.enterEditMode('Layer_1');
        markup = editor.getMarkup(id);
        markup.isTemp = true;
        markups.push(markup);
    }

    //Add Markups for Links
    let activeAttachment = store.state.MARKUPS.activeAttachment;
    let activePageNumber = store.state.MARKUPS.activeAttachmentPage;
    let activeForgePage = activeAttachment.pagesMarkups.find(x => x.pageId == activePageNumber);
    if (activeForgePage && activeForgePage.links && activeForgePage.links.length > 0) {
        templateStyle["stroke-color"] = "#19af9a";
        templateStyle["fill-opacity"] = 0;
        for (let i = 0; i < activeForgePage.links.length; i++) {
            const link = activeForgePage.links[i];
            id = store.state.forgeService.newGuid();
            let createRect = new avemc.CreateRectangle(editor, id, link.position, { 'x': link.width, 'y': link.height }, 0, templateStyle)
            createRect.execute();
            editor.enterEditMode('Layer_1');
            markup = editor.getMarkup(id);
            markup.isTemp = true;
            markups.push(markup);

            id = store.state.forgeService.newGuid();
            let createText = new avemc.CreateText(editor, id, link.position, { 'x': link.width, 'y': link.height }, link.name, templateStyle)
            createText.execute();
            editor.enterEditMode('Layer_1');
            markup = editor.getMarkup(id);
            markup.isTemp = true;
            markups.push(markup);
        }
    }

    return markups;
}


export function deletePrintMarkups(editor, markups) {
    if (markups && markups.length > 0) {
        for (let i = 0; i < markups.length; i++) {
            const markup = markups[i];
            editor.enterEditMode('Layer_1');
            editor.selectMarkup(markup);
            editor.deleteMarkup(markup);
        }
    }
}

export function getModelClientDimensions(viewer, model) {
    let modelBoundingBox = model.getBoundingBox();
    let bBoxClientMax = viewer.worldToClient(modelBoundingBox.max);
    let bBoxClientMin = viewer.worldToClient(modelBoundingBox.min);
    let bBoxClientSize = bBoxClientMax.sub(bBoxClientMin);
    return bBoxClientSize;
}


export function _addEvent(elm, evt, callback) {
    if (elm == null || typeof (elm) == undefined)
        return;
    let _hasEventListeners = window.addEventListener;
    if (_hasEventListeners)
        elm.addEventListener(evt, callback, false);
    else if (elm.attachEvent)
        elm.attachEvent('on' + evt, callback);
    else
        elm['on' + evt] = callback;
}

export function mergeTwoGuids(guid1, guid2) {
    let newGuid = '';
    for (let i = 0; i < guid1.length; i++) {
        let char = (i % 2) === 0 ? guid1[i] : guid2[i];
        newGuid += char
    }
    return newGuid
}

export function groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export function removeItemOnce(arr, value) {
    let index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}

export function removeItemAll(arr, value) {
    let i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}

export function showVirtualKeyboardOnFocus(e) {
    let showKeyboard = !store.state.userSettings.displaySettings.hideKeyboard;
    if (!(('ontouchstart' in window || navigator.maxTouchPoints) && showKeyboard)) return;
    store.state.currentInputElement = e.target;
    store.state.virtualKeyboardShown = true;
}


//cache helpers
let registrationService = null;
async function clearCache(urn) {
    try {
        const result = submitWorkerTask({ operation: 'CLEAR_URN', urn: urn });
        console.log('One Model cache cleared successfully', result);
    } catch (err) {
        console.error('Could not be clear model cache', err);
    }
}
async function initServiceWorker_CacheAll() {
    try {
        registrationService = await navigator.serviceWorker.register(config.apiUrl + '/service-worker-cache-all.js');
        console.log('Service worker registered', registrationService.scope);
    } catch (err) {
        console.error('Could not register service worker', err);
    }
}

function submitWorkerTask(task) {
    const channel = new MessageChannel();
    channel.port1.onmessage = function (event) {
        if (event.data.error) {
            console.log(event.data)
            return event.data;
        } else {
            return event.data;
        }
    };
    registrationService.active?.postMessage(task, [channel.port2]);
}

export function objectToQueryParams(obj) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(obj)) {
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    }
    return params.toString();
}